/* eslint-disable max-len */
import React from "react"
import styled from "styled-components"
import Select from "react-select"
import cookie from "react-cookies"
import {
  get,
  isObject,
  uniqBy,
  isEqual,
  isArray,
  isEmpty,
} from "lodash"
import moment from "moment"
import { ToastContainer, toast } from "react-toastify"
import { Link, withRouter } from "react-router-dom"
import {
  addCommas,
  USCurrencyFormat,
  deformatCurrency,
} from "shared/currencyUtils"
import { List, Skeleton, Button as AntdButton, Radio, InputNumber } from "antd"
import Loader from "dumbComponents/common/UI/Loader"
import container from "container/BrokerDashboard/globalPagesContainer"
import Button from "dumbComponents/common/UI/Button"
import AgentSearch from "dumbComponents/BrokerDashboard/Components/AgentSearch"
import { setTimeout } from "window-or-global"
import ListValues from "./List.json"
import TextInput from "../../Comp/TextInput"
import GoogleLocation from "../../../../components/GoogleAutoComplete"
import ClientSelector, { orderClientsByDealType, isOtherSource } from "./ClientSelector"
import ClientSearch from "./ClientSearch"
import {
  TRANSACTION_TYPE,
  COMMISSION_TYPE,
  US_OBJ,
  FILE_TYPES,
  FILE_TYPES_LISTING,
  RADIUS_TRANSACTION_TYPE,
} from "../FieldData"
import { getSource } from "../Util"
import EscrowDrawer from "./EscrowDrawer"
import Tick from "../Images/Tick.svg"
import { capitalizeFirstLetter } from "../../../../services/Utils"

const Wrap = styled.div`
  margin: 20px auto;
  max-width: 1000px;
  padding: 20px 20px 200px 20px;
`

const Row = styled.div`
  display: flex;
  margin-top: 30px;
  flex-wrap: wrap;
  gap: 14px;

  ${props => props.noMargin && `
    margin-top: 0px;
  `}

  ${props => props.isEscrow && `
    flex-direction: column;
  `}
`

const Col = styled.div`
  flex: 1;
  margin-right: 20px;
  margin-bottom: 0px;
  &:last-child {
    margin-right: 0px;
  }
`

const Header = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  > div {
    &:nth-child(1) {
      flex: 1;
    }
    &:nth-child(2) {
    }
  }
`

const Label = styled.div`
  color: #A3A3A3;
  text-transform: uppercase;
  letter-spacing: 2px;
  font-size: 14px;
  width: 100%;
  margin-bottom: 10px;
  height: 16px;
  ${props => props.error && `
    font-size: 11px;
    color: red;
    margin-top: 7px;
    letter-spacing: 1px;
    width: 110%;
  `}
  ${props => props.skyslope && `
    margin-bottom: 3px;
  
  `}
`
const VendorLabel = styled.div`
  font-size: 12px;
  letter-spacing: 2px;
  color: black;
`

const SectionWrap = styled.div`
  padding: 40px;
  border-radius: 20px;
  border: 1px solid #ccc;
  position: relative;
  margin-bottom: 40px;

  @keyframes breath-animation {
    0% { background: transparent; border: 1px solid #ccc; }
    50% { background: #ffcecb; border: 1px solid #fd6459; }
  }

  ${props => props.isAnimate && `
    animation-name: breath-animation;
    animation-duration: 1.5s;
    animation-iteration-count: 3;
  `}

  > h6 {
    top: -16px;
    left: 40px;
    position: absolute;
    background: #fff;
    padding: 5px 16px;
    margin: 0px;
    font-size: 16px;
    font-weight: 700;
    color: #999;
  }

`
const TCDetails = styled.div`
  display: flex;
  margin-top: 8px;
`

const UploadWrap = styled.div`

`
const EscrowWrap = styled.div`
  display: flex;
  flex-direction: column;
`
const TitleWrap = styled.div`
  display: flex;
  justify-content: space-between;
`
const Title = styled.div`
  font-size: 18px;
`
const InfoWrap = styled.div`
  display: flex;
  flex-direction: column;
`
const CalculateButton = styled(Button)`
  height: 42px;
  align-self: flex-end;
`

const SelectedButton = styled(AntdButton)`
  width: 100px;
`

const SelectedAgentView = styled.div`

`

const Input = styled.input`
  width: 100%;
  // padding: 10px;
  height: 40px; 
  border: 1px solid #ccc;
  border-radius: 4px;
`

class AddNewDeal extends React.PureComponent {
  state = {
    files: [],
    localArr: [], 
    form: {
      // RAW
      active_listing_status: null,
      agent_commission: null,
      agent_email: "",
      agent_id: null,
      city: "",
      client_email: "",
      client_name: null,
      client_type: null,
      clients: [],
      closed_on: null,
      confirmed_closed_on: null,
      co_listing_agents: null,
      // agents_info: null, 
      commision_percentage: null,
      closing_agent_commision_percentage: null,
      commission_type: null,
      primary_agent_commission_type: null,
      primary_agent_commission_split: null,
      primary_agent_misc_fees: null,
      primary_agent_fixed_fee: null,
      team_split_fixed_fee: null,
      contract_on: null,
      created_at: moment(new Date()).unix(),
      date_of_listing_submission: moment().format("YYYY-MM-DD HH:mm:ss"),
      escrow_officer_email: null,
      escrow_officer_phone: null,
      tc_name: null,
      tc_email: null,
      tc_phone: null,
      file_type: null,
      fixed_fee: null,
      gross_commission: null,
      hoa_guidelines: null,
      is_all_cash_offer: null,
      //is_co_listed_deal: null,
      is_radius_lead: null,
      is_radius_tc_to_open_escrow: null,
      lease_commencement_on: null,
      lender_email_address: null,
      rent_amount_term: null,
      rent_amount: null,
      other_rent_amount_term: null,
      list_price: null,
      listing_address: null,
      price: null,
      radius_transaction_fee: null,
      row_created_at: moment().format("YYYY-MM-DD HH:mm:ss"),
      //row_updated_at: null,
      schedule_sign_post_installation: null,
      radius_transaction_type: "",
      sign_post_installation_location: null,
      sign_post_installation_on: null,
      sign_post_installation_riders: null,
      source: null,
      state: null,
      team_split_percentage: null,
      team_split_type: null,
      transaction_type: null,
      zipcode: null,
      skyslope_unique_id: "",
      listing_date: null,
      listing_expiration_date: null,
      is_using_deal_tc: null,
      is_coupon_applied: 0,
      brokerage_fee: null,
      agent_payout_fee: null,
      tc_fee: null,
      audit_fee: null,
      primary_agent_radius_fee: null,
      pending_subscription_fee: null,
      e_and_o_fee: null,
      referral_fee: null,
      misc_fee_amounts: "", 
      new_referral_fee: null,
      gross_commission_after_deductions: null,
      commission_deductions: null,
      representing_broker_commission_type: null,
      representing_broker_commission_percentage: null,
      representing_broker_commission_fixed_fee: null,
      representing_broker_gross_commission: null,
      representing_broker_commission_deductions: null,
      representing_broker_gross_commission_after_deductions: null,
      brokerage_net_commission: null,
      receivable_status: null,
      total_primary_agent_commission: null, // Added for two-way calculation
      total_primary_agent_team_commission: null, // Added for team commission two-way calculation
      contribution_to_internal_cap_manual: null,
      progress_to_internal_cap_new: null,
      remaining_to_internal_cap_new: null,
    },
    hasUserUpdatedFields: {
      pending_subscription_fee: false,
      brokerage_fee: false,
      audit_fee: false,
      eno_fee: false,
      internal_referral_fee: false,
      radius_transaction_fee: false,
      misc_fees: false,
    },
    errorFields: {},
    isSelected: null,
    isLoading: false,
    hasChangedBrokerageNetCommission: false,
    hasChangedGrossCommission: false,
    hasChangedRepresentingBrokerGrossCommission: false,
    hasChangedSplits: false,
  }

  parseMoneyField = (raw) => {
    if (raw === null || raw === undefined || raw === "") return 0;
    if (typeof raw === "number") return raw;
    const n = parseFloat(String(raw).replace(/[^0-9.-]/g, ""));
    return isNaN(n) ? 0 : n;
  }

  // Helper to get current gross commission after deductions
  getGrossCommissionAfterDeductions = () => {
    const { form } = this.state;
    const grossCommission = this.parseMoneyField(form.gross_commission);
    const commissionDeductions = this.parseMoneyField(form.commission_deductions);
    return grossCommission - commissionDeductions;
  }

  // Handler for when primary agent split percentage changes
  handlePrimaryAgentSplitChange = (event) => {
    const { value } = event.target;
    const newSplitPercentage = value || "";
    const grossCommissionAfterDeductions = this.getGrossCommissionAfterDeductions();
    
    let newTotalPrimaryAgentCommission = 0;
    if (grossCommissionAfterDeductions > 0) {
      newTotalPrimaryAgentCommission = (grossCommissionAfterDeductions * newSplitPercentage) / 100;
    }

    this.setState(prevState => ({
      form: {
        ...prevState.form,
        primary_agent_commission_split: newSplitPercentage,
        total_primary_agent_commission: newTotalPrimaryAgentCommission,
      },
      hasChangedSplits: true // Mark as manually changed
    }));
  }

  // Handler for when total primary agent commission amount changes
  handleTotalPrimaryAgentCommissionChange = (event) => {
    const rawValue = event.target.value;
    const newTotalCommission = parseFloat(deformatCurrency(rawValue)) || 0;
    const grossCommissionAfterDeductions = this.getGrossCommissionAfterDeductions();

    let newSplitPercentage = 0;
    if (grossCommissionAfterDeductions > 0) { // Avoid division by zero
      newSplitPercentage = (newTotalCommission / grossCommissionAfterDeductions) * 100;
      // Optionally, cap the percentage at a reasonable max like 100 or more if needed
      // newSplitPercentage = Math.min(newSplitPercentage, 100); 
    }
    
    this.setState(prevState => ({
      form: {
        ...prevState.form,
        total_primary_agent_commission: newTotalCommission,
        primary_agent_commission_split: newSplitPercentage,
      },
      hasChangedSplits: true // Mark as manually changed
    }));
  }

  // Handler for when a specific co-agent's split percentage changes
  handleCoAgentSplitChange = (agentIndex, event) => {
    const { form } = this.state;
    const { value } = event.target;
    let newSplitForCoAgent = null;

    if (value === "") {
      newSplitForCoAgent = null;
    } else {
      const parsed = value || "";
      newSplitForCoAgent = isNaN(parsed) ? 0 : parsed; // Default to 0 if invalid non-empty string
    }

    const grossCommissionAfterDeductions = this.getGrossCommissionAfterDeductions();
    let newTotalCommissionForCoAgent = null;

    if (newSplitForCoAgent !== null && grossCommissionAfterDeductions > 0) {
      newTotalCommissionForCoAgent = (grossCommissionAfterDeductions * newSplitForCoAgent) / 100;
    }

    const updatedCoListingAgents = form.co_listing_agents.map((agent, idx) =>
      idx === agentIndex ? {
        ...agent,
        commission_split: newSplitForCoAgent,
        total_agent_commission: newTotalCommissionForCoAgent
      } : agent
    );

    this.setState(prevState => ({
      form: {
        ...prevState.form,
        co_listing_agents: updatedCoListingAgents
      },
      // Consider if hasChangedSplits is appropriate here or a more specific co-agent flag
    }));
  }
  calculateCoAgentTeamCommission = (teamSplitType, teamSplitPercentage, teamSplitFixedFee, totalAgentCommission) => {
    let totalAgentTeamCommission = 0;
  
    // Ensure all values are parsed as numbers
    const parsedTotalAgentCommission = parseFloat(totalAgentCommission) || 0;
    const parsedTeamSplitPercentage = parseFloat(teamSplitPercentage) || 0;
    const parsedTeamSplitFixedFee = parseFloat(teamSplitFixedFee) || 0;
  
    // Calculate based on team split type
    if (parsedTotalAgentCommission > 0) {
      if (teamSplitType === "percentage") {
        totalAgentTeamCommission = (parsedTotalAgentCommission * parsedTeamSplitPercentage) / 100;
      } else if (teamSplitType === "fixed_fee") {
        totalAgentTeamCommission = parsedTeamSplitFixedFee;
      } else if (teamSplitType === "both") {
        const percentageCommission = (parsedTotalAgentCommission * parsedTeamSplitPercentage) / 100;
        totalAgentTeamCommission = percentageCommission + parsedTeamSplitFixedFee;
      }
    }

    return totalAgentTeamCommission.toFixed(2);
  };
  // Handler for when a specific co-agent's total commission amount changes
  handleCoAgentTotalCommissionChange = (agentIndex, event) => {
    const { form } = this.state;
    const rawValue = event.target.value;
    let newTotalCommissionForCoAgent = null;

    if (rawValue === "" || rawValue === "$") {
      newTotalCommissionForCoAgent = null;
    } else {
      const deformatted = deformatCurrency(rawValue);
      const parsed = parseFloat(deformatted);
      newTotalCommissionForCoAgent = isNaN(parsed) ? 0 : parsed; // Default to 0 if invalid non-empty string
    }
    
    const grossCommissionAfterDeductions = this.getGrossCommissionAfterDeductions();
    let newCommissionSplitForCoAgent = null;

    if (newTotalCommissionForCoAgent !== null && grossCommissionAfterDeductions > 0) {
      newCommissionSplitForCoAgent = (newTotalCommissionForCoAgent / grossCommissionAfterDeductions) * 100;
    }

    const updatedCoListingAgents = form.co_listing_agents.map((agent, idx) =>
      idx === agentIndex ? {
        ...agent,
        total_agent_commission: newTotalCommissionForCoAgent,
        commission_split: newCommissionSplitForCoAgent
      } : agent
    );

    this.setState(prevState => ({
      form: {
        ...prevState.form,
        co_listing_agents: updatedCoListingAgents
      },
      // Consider if hasChangedSplits is appropriate here
    }));
  }
  handlePrimaryTeamFeeChange = () => {
    const { form } = this.state;
  
    const fixedFee = parseFloat(form.team_split_fixed_fee) || 0;
    const percentage = parseFloat(form.team_split_percentage) || 0;
    const baseCommission = parseFloat(form.total_primary_agent_commission) || 0;
    const teamCommissionType = form.team_split_type;
  
    let newTotalTeamCommission = 0;
    if (baseCommission > 0) {
      if (teamCommissionType === "percentage") {
        newTotalTeamCommission = (baseCommission * percentage) / 100;
      }
      if (teamCommissionType === "fixed_fee") {
        newTotalTeamCommission = fixedFee;
      }
      if (teamCommissionType === "both") {
        const percentageCommission = (baseCommission * percentage) / 100;
        newTotalTeamCommission = percentageCommission + fixedFee;
      }
    }
  
    this.setState((prevState) => ({
      form: {
        ...prevState.form,
        total_primary_agent_team_commission: newTotalTeamCommission,
      },
    }));
  };
  
  // Handler for when primary agent team split percentage changes
  handlePrimaryTeamSplitPercentageChange = (event) => {
    const { form } = this.state;
    const { value } = event.target;
    const newTeamSplitPercentage = value || "";
    const baseCommission = parseFloat(form.total_primary_agent_commission) || 0;
    const fixedFee = parseFloat(form.team_split_fixed_fee) || 0;
    const teamCommissionType = form.team_split_type;


    let newTotalTeamCommission = 0;
    if (baseCommission > 0) {
      if(teamCommissionType === "percentage") {
      newTotalTeamCommission = (baseCommission * newTeamSplitPercentage) / 100;
      }
      if(teamCommissionType === "fixed_fee") {
        newTotalTeamCommission = fixedFee;
      }
      if(teamCommissionType === "both") {
        const percentageCommission = (baseCommission * newTeamSplitPercentage) / 100;
        newTotalTeamCommission = percentageCommission + fixedFee;
      }
    }

    this.setState(prevState => ({
      form: {
        ...prevState.form,
        team_split_percentage: newTeamSplitPercentage,
        total_primary_agent_team_commission: newTotalTeamCommission,
      }
    }));
  }

  // Handler for when total primary agent team commission amount changes
  handleTotalPrimaryAgentTeamCommissionChange = (event) => {
    const { form } = this.state;
    const rawValue = event.target.value;
    const newTotalTeamCommission = parseFloat(deformatCurrency(rawValue)) || 0;
    const baseCommission = parseFloat(form.total_primary_agent_commission) || 0;

    let newTeamSplitPercentage = 0;
    if (baseCommission > 0) { // Avoid division by zero
      newTeamSplitPercentage = (newTotalTeamCommission / baseCommission) * 100;
    }
    
    this.setState(prevState => ({
      form: {
        ...prevState.form,
        total_primary_agent_team_commission: newTotalTeamCommission,
        team_split_percentage: newTeamSplitPercentage,
      }
    }));
  }

  // Handler for when a co-agent's team split percentage changes
  handleCoAgentTeamSplitPercentageChange = (agentIndex, event) => {
    const { form } = this.state;
    const { value } = event.target;
    const coAgent = form.co_listing_agents[agentIndex];
    if (!coAgent) return;

    const newTeamSplitPercentage = value || "";
    const baseCommission = parseFloat(coAgent.total_agent_commission) || 0;
    const fixedFee = parseFloat(coAgent.team_split_fixed_fee) || 0;
    let newTotalTeamCommission = 0;
  if (baseCommission > 0) {
    if (coAgent.team_split_type === "percentage") {
      newTotalTeamCommission = (baseCommission * newTeamSplitPercentage) / 100;
    } else if (coAgent.team_split_type === "fixed_fee") {
      newTotalTeamCommission = fixedFee;
    } else if (coAgent.team_split_type === "both") {
      const percentageCommission = (baseCommission * newTeamSplitPercentage) / 100;
      newTotalTeamCommission = percentageCommission + fixedFee;
    }
  }

    const updatedCoListingAgents = form.co_listing_agents.map((agent, idx) =>
      idx === agentIndex ? {
        ...agent,
        team_split_percentage: newTeamSplitPercentage,
        total_agent_team_commission: newTotalTeamCommission
      } : agent
    );
    this.setState(prevState => ({ form: { ...prevState.form, co_listing_agents: updatedCoListingAgents } }));
  }

  // Handler for when a co-agent's total team commission amount changes
  handleCoAgentTotalTeamCommissionChange = (agentIndex, event) => {
    const { form } = this.state;
    const rawValue = event.target.value;
    const coAgent = form.co_listing_agents[agentIndex];
    if (!coAgent) return;

    const newTotalTeamCommission = parseFloat(deformatCurrency(rawValue)) || 0;
    const roundedNewTotalTeamCommission = parseFloat(newTotalTeamCommission.toFixed(2));
    const baseCommission = parseFloat(coAgent.total_agent_commission) || 0;
    let newTeamSplitPercentage = 0;

    if (baseCommission > 0) {
      newTeamSplitPercentage = (roundedNewTotalTeamCommission / baseCommission) * 100;
    }

    const updatedCoListingAgents = form.co_listing_agents.map((agent, idx) =>
      idx === agentIndex ? {
        ...agent,
        total_agent_team_commission: roundedNewTotalTeamCommission,
        team_split_percentage: newTeamSplitPercentage
      } : agent
    );
    this.setState(prevState => ({ form: { ...prevState.form, co_listing_agents: updatedCoListingAgents } }));
  }

  componentDidUpdate(prevProps, prevState) {
    const { form } = this.state;
    const clientTypeVal = isObject(form.client_type) ? form.client_type.value : form.client_type;
    const prevClientTypeVal = isObject(prevState.form.client_type)
      ? prevState.form.client_type.value
      : prevState.form.client_type;

    // Check if misc_fee_amounts has changed
    if (form?.misc_fee_amounts !== prevState?.form?.misc_fee_amounts) {
      // Parse the pipe-separated string into an array of numbers
      if (form?.misc_fee_amounts) {
        const parsedArr = form.misc_fee_amounts
          .split("|")
          .map(item => item.trim())
          .filter(Boolean)
          .map(item => {
            const num = Number(item);
            return isNaN(num) ? 0 : num; // Ensure we never store NaN values
          });
        
        this.setState({
          localArr: parsedArr.length > 0 ? parsedArr : [0] // Ensure at least one input
        });
      } else {
        this.setState({ localArr: [0] });
      }
    }
    
    // Referral: compute representing broker gross before referral gross commission (same tick state is stale otherwise).
    if (clientTypeVal === "referral") {
      if (
        prevState.form.price !== form.price ||
        prevState.form.rent_amount !== form.rent_amount ||
        prevState.form.representing_broker_commission_percentage !== form.representing_broker_commission_percentage ||
        prevState.form.representing_broker_commission_fixed_fee !== form.representing_broker_commission_fixed_fee ||
        (prevState.form.representing_broker_commission_type?.value !== form.representing_broker_commission_type?.value)
      ) {
        if (!this.state.hasChangedRepresentingBrokerGrossCommission) {
          this.calculateRepresentingBrokerGrossCommission();
        }
      }
    }

    // Check if price, commission percentage, fixed fee, or commission type has changed
    if (
      prevState.form.price !== form.price ||
      prevState.form.commision_percentage !== form.commision_percentage ||
      prevState.form.fixed_fee !== form.fixed_fee ||
      (prevState.form.commission_type?.value !== form.commission_type?.value) ||
      // Also check if gross_commission or commission_deductions changed to update total_primary_agent_commission
      prevState.form.gross_commission !== form.gross_commission ||
      prevState.form.commission_deductions !== form.commission_deductions ||
      prevClientTypeVal !== clientTypeVal ||
      (clientTypeVal === "referral"
        && (prevState.form.representing_broker_gross_commission !== form.representing_broker_gross_commission
          || prevState.form.representing_broker_commission_deductions !== form.representing_broker_commission_deductions))
    ) {
      // Only auto-calculate if the user hasn't manually edited gross commission
      if (!this.state.hasChangedGrossCommission) {
        if (clientTypeVal === "referral") {
          setTimeout(() => this.calculateGrossCommission(), 0);
        } else {
          this.calculateGrossCommission();
        }
      }
      // If primary_agent_commission_split exists, recalculate total_primary_agent_commission
      if (form.primary_agent_commission_split !== null && form.primary_agent_commission_split !== undefined) {
        const grossCommAfterDeductions = this.getGrossCommissionAfterDeductions();
        const newTotalPrimaryComm = (grossCommAfterDeductions * (parseFloat(form.primary_agent_commission_split) || 0)) / 100;
        if (form.total_primary_agent_commission !== newTotalPrimaryComm) {
           this.setState(prevStateInner => ({ // Use functional setState if depending on prev state
            form: {
              ...prevStateInner.form,
              total_primary_agent_commission: newTotalPrimaryComm
            }
          }));
        }
      }
    }

    // Check if co_listing_agents array length has changed
    if (
      (!prevState.form.co_listing_agents && form.co_listing_agents) ||
      (prevState.form.co_listing_agents && !form.co_listing_agents) ||
      (prevState.form.co_listing_agents?.length !== form.co_listing_agents?.length)
    ) {
      // Update agent splits if co-agent count changes
      this.updateAgentSplits();
    }
    // For co-agents, if gross_commission or commission_deductions changed, update their total_agent_commission
    if (Array.isArray(form.co_listing_agents)) {
      const grossCommAfterDeductions = this.getGrossCommissionAfterDeductions();
      const needsCoAgentUpdate = form.co_listing_agents.some((agent, index) => {
        if (agent.commission_split !== null && agent.commission_split !== undefined) {
          const newTotalCoAgentComm = (grossCommAfterDeductions * (parseFloat(agent.commission_split) || 0)) / 100;
          return agent.total_agent_commission !== newTotalCoAgentComm;
        }
        return false;
      });

      if (needsCoAgentUpdate) {
        this.setState(prevStateInner => ({
          form: {
            ...prevStateInner.form,
            co_listing_agents: prevStateInner.form.co_listing_agents.map(agent => {
              if (agent.commission_split !== null && agent.commission_split !== undefined) {
                const newTotalCoAgentComm = (grossCommAfterDeductions * (parseFloat(agent.commission_split) || 0)) / 100;
                return { ...agent, total_agent_commission: newTotalCoAgentComm };
              }
              return agent;
            })
          }
        }));
      }
    }
  }
  
  componentDidMount() {
    const {
      match,
      location,
      getSecureIdForTC,
      getAllDealsListing,
      getVendorDetails,
      getVendorDetailsResponse,
      setAllVendors,
      selectedId,
      isCreatingDeal,
    } = this.props
    const { form } = this.state
    
    // Initialize localArr from misc_fee_amounts
    if (form?.misc_fee_amounts) {
      const parsedArr = form.misc_fee_amounts
        .split("|")
        .map(item => item.trim())
        .filter(Boolean)
        .map(item => {
          const num = Number(item);
          return isNaN(num) ? 0 : num; // Ensure we never store NaN values
        });
      
      this.setState({
        localArr: parsedArr.length > 0 ? parsedArr : [0] // Ensure at least one input
      });
    } else {
      // Always add an initial empty fee if none exist
      this.setState({
        localArr: [0]
      });
    }
    
    const { dealId, agentId } = match.params
    let dealIdFinal = dealId
    if (dealId && dealId.includes("?")) {
      dealIdFinal = dealId.split("?")
      dealIdFinal  = dealIdFinal[0]
    }
    
    const defaultCoAgentStructure = {
      firstname: "",
      lastname: "",
      name: "", // Often an alias for firstname in agents_info
      email: "",
      phone: "",
      agent_id: null,
      brokerage_fee: 0,
      audit_fee: 0,
      pending_subscription_fee: 0,
      eno_fee: 0,
      internal_referral_fee: 0,
      radius_fee: 0, // This will be calculated
      misc_fees: 0,
      team_split_type: "percentage", // Default
      team_split_percentage: 0,
      commission_split: null, // Default for co-agents
      fixed_fee: 0,
      team_split_fixed_fee: 0,
      agent_reported_income: 0,
      co_agent_net_commission: 0,
      progress_to_radius_cap: 0,
      progress_to_internal_cap: 0,
      progress_to_internal_cap_new: 0,
      remaining_to_internal_cap_new: null,
      contribution_to_internal_cap_manual: null,
      receivable_status: null,
      is_primary: 0, // Explicitly co-agent
      total_agent_commission: null, // Initialize for new co-agent
      total_agent_team_commission: null, // Initialize for new co-agent team commission
    };
    
    if (!isEmpty(location?.state)) {
      const { deal: finalDeal } = location && location.state || {}
      const deal = finalDeal[0] || finalDeal || null
      if (dealId && deal) {
        getAllDealsListing({
          type: "agent",
          type_deal: "deal",
          dealId: dealIdFinal,
          agentId,
          transactionType: "Contract",
        })
        getSecureIdForTC({ agentId })
        getVendorDetails({ agentId, dealId: dealIdFinal })
        
        // Initialize co_listing_agents from agents_info if needed
        if (deal.agents_info && deal.agents_info.length > 0) {
          const coAgentsFromAgentsInfo = deal.agents_info.filter(agent => agent.is_primary === 0);

          if (coAgentsFromAgentsInfo.length > 0) {
            if (!deal.co_listing_agents || deal.co_listing_agents.length === 0) {
              // Case 1: deal.co_listing_agents is empty or doesn't exist, create from agents_info
              deal.co_listing_agents = coAgentsFromAgentsInfo.map(agentFromInfo => {
                let newCoAgent = {
                  ...defaultCoAgentStructure,
                  ...agentFromInfo, // Spread data from agents_info
                  is_primary: 0, // Ensure
                };

                // Specific post-merge adjustments
                newCoAgent.firstname = newCoAgent.firstname || newCoAgent.name || "";
                newCoAgent.lastname = newCoAgent.lastname || "";
                newCoAgent.email = newCoAgent.email || "";

                if (newCoAgent.team_split_type && isObject(newCoAgent.team_split_type)) {
                  newCoAgent.team_split_type = newCoAgent.team_split_type.value;
                } else if (!newCoAgent.team_split_type) {
                  newCoAgent.team_split_type = deal.team_split_type ? (isObject(deal.team_split_type) ? deal.team_split_type.value : deal.team_split_type) : "percentage";
                }

                if (newCoAgent.receivable_status && isObject(newCoAgent.receivable_status)) {
                  newCoAgent.receivable_status = newCoAgent.receivable_status.value;
                } else if (!newCoAgent.receivable_status) {
                  newCoAgent.receivable_status = deal.receivable_status ? (isObject(deal.receivable_status) ? deal.receivable_status.value : deal.receivable_status) : null;
                }
                
                if (newCoAgent.commission_split === null || newCoAgent.commission_split === undefined) {
                  newCoAgent.commission_split = null; // No default split
                }
                // Calculate total_agent_commission if split is present
                if (newCoAgent.commission_split !== null && deal.gross_commission !== null && deal.commission_deductions !== null) {
                  const grossComm = parseFloat(deal.gross_commission) || 0;
                  const commDeduct = parseFloat(deal.commission_deductions) || 0;
                  const grossCommAfterDeduct = grossComm - commDeduct;
                  if (grossCommAfterDeduct > 0) {
                    newCoAgent.total_agent_commission = (grossCommAfterDeduct * (parseFloat(newCoAgent.commission_split) || 0)) / 100;
                  }
                } else if (newCoAgent.total_agent_commission !== null && (newCoAgent.commission_split === null || newCoAgent.commission_split === undefined) && deal.gross_commission !== null && deal.commission_deductions !== null) {
                    const grossComm = parseFloat(deal.gross_commission) || 0;
                    const commDeduct = parseFloat(deal.commission_deductions) || 0;
                    const grossCommAfterDeduct = grossComm - commDeduct;
                    if (grossCommAfterDeduct > 0) {
                         newCoAgent.commission_split = ((parseFloat(newCoAgent.total_agent_commission) || 0) / grossCommAfterDeduct) * 100;
                    }
                }
                // Calculate total_agent_team_commission if team_split_percentage and total_agent_commission are present
               

                if ((newCoAgent.team_split_percentage !== null && newCoAgent.total_agent_commission !== null) || (newCoAgent.team_split_fixed_fee !== null)) {
                  const baseCoAgentComm = parseFloat(newCoAgent.total_agent_commission) || 0;
                  if (baseCoAgentComm > 0) {
                    if (newCoAgent.team_split_type === "percentage") {
                      newCoAgent.total_agent_team_commission = (baseCoAgentComm * (parseFloat(newCoAgent.team_split_percentage) || 0)) / 100;
                    } else if (newCoAgent.team_split_type === "fixed_fee") {
                      newCoAgent.total_agent_team_commission = parseFloat(newCoAgent.team_split_fixed_fee) || 0;
                    } else if (newCoAgent.team_split_type === "both") {
                      const percentageCommission = (baseCoAgentComm * (parseFloat(newCoAgent.team_split_percentage) || 0)) / 100;
                      const fixedFee = parseFloat(newCoAgent.team_split_fixed_fee) || 0;
                      newCoAgent.total_agent_team_commission = percentageCommission + fixedFee;
                    }
                  }
                }
                return newCoAgent;
              });
            } else {
              // Case 2: deal.co_listing_agents already exists, merge with agents_info
              deal.co_listing_agents = deal.co_listing_agents.map((existingCoAgentData) => {
                const matchedAgentInfo = coAgentsFromAgentsInfo.find(
                  ai => ai.agent_id === existingCoAgentData.agent_id
                );

                let mergedCoAgent = {
                  ...defaultCoAgentStructure,
                  ...(matchedAgentInfo || {}), // Spread data from agents_info match
                  ...existingCoAgentData,      // Spread existing data (takes precedence for defined fields)
                  is_primary: 0, // Ensure
                };
                
                // Specific post-merge adjustments
                mergedCoAgent.firstname = mergedCoAgent.firstname || mergedCoAgent.name || "";
                mergedCoAgent.lastname = mergedCoAgent.lastname || "";
                mergedCoAgent.email = mergedCoAgent.email || "";

                if (mergedCoAgent.team_split_type && isObject(mergedCoAgent.team_split_type)) {
                  mergedCoAgent.team_split_type = mergedCoAgent.team_split_type.value;
                } else if (!mergedCoAgent.team_split_type) {
                  mergedCoAgent.team_split_type = deal.team_split_type ? (isObject(deal.team_split_type) ? deal.team_split_type.value : deal.team_split_type) : "percentage";
                }

                if (mergedCoAgent.receivable_status && isObject(mergedCoAgent.receivable_status)) {
                  mergedCoAgent.receivable_status = mergedCoAgent.receivable_status.value;
                } else if (!mergedCoAgent.receivable_status) {
                   mergedCoAgent.receivable_status = deal.receivable_status ? (isObject(deal.receivable_status) ? deal.receivable_status.value : deal.receivable_status) : null;
                }

                if (mergedCoAgent.commission_split === null || mergedCoAgent.commission_split === undefined) {
                  mergedCoAgent.commission_split = null; // No default split, rely on existing or defaultCoAgentStructure
                }
                // Calculate total_agent_commission or commission_split if one is present and the other isn't
                const currentGross = mergedCoAgent.gross_commission !== undefined ? mergedCoAgent.gross_commission : (deal.gross_commission || 0);
                const currentDeductions = mergedCoAgent.commission_deductions !== undefined ? mergedCoAgent.commission_deductions : (deal.commission_deductions || 0);
                const grossComm = parseFloat(currentGross) || 0;
                const commDeduct = parseFloat(currentDeductions) || 0;
                const grossCommAfterDeduct = grossComm - commDeduct;

                if (mergedCoAgent.commission_split !== null && mergedCoAgent.commission_split !== undefined && (mergedCoAgent.total_agent_commission === null || mergedCoAgent.total_agent_commission === undefined)) {
                  if (grossCommAfterDeduct > 0) {
                    mergedCoAgent.total_agent_commission = (grossCommAfterDeduct * (parseFloat(mergedCoAgent.commission_split) || 0)) / 100;
                  }
                } else if ((mergedCoAgent.commission_split === null || mergedCoAgent.commission_split === undefined) && mergedCoAgent.total_agent_commission !== null && mergedCoAgent.total_agent_commission !== undefined) {
                  if (grossCommAfterDeduct > 0) {
                    mergedCoAgent.commission_split = ((parseFloat(mergedCoAgent.total_agent_commission) || 0) / grossCommAfterDeduct) * 100;
                  }
                }
                // Calculate total_agent_team_commission if team_split_percentage and total_agent_commission are present
                if (mergedCoAgent.team_split_percentage !== null && mergedCoAgent.team_split_percentage !== undefined && mergedCoAgent.total_agent_commission !== null && mergedCoAgent.total_agent_commission !== undefined) {
                  const baseCoAgentTotalComm = parseFloat(mergedCoAgent.total_agent_commission) || 0;
                  if (baseCoAgentTotalComm > 0) {
                    if (mergedCoAgent.team_split_type === "percentage") {
                      // Calculate based on percentage
                      mergedCoAgent.total_agent_team_commission = 
                        (baseCoAgentTotalComm * (parseFloat(mergedCoAgent.team_split_percentage) || 0)) / 100;
                    } else if (mergedCoAgent.team_split_type === "fixed_fee") {
                      // Use the fixed fee directly
                      mergedCoAgent.total_agent_team_commission = parseFloat(mergedCoAgent.team_split_fixed_fee) || 0;
                    } else if (mergedCoAgent.team_split_type === "both") {
                      // Sum of percentage-based commission and fixed fee
                      const percentageCommission = 
                        (baseCoAgentTotalComm * (parseFloat(mergedCoAgent.team_split_percentage) || 0)) / 100;
                      const fixedFee = parseFloat(mergedCoAgent.team_split_fixed_fee) || 0;
                      mergedCoAgent.total_agent_team_commission = percentageCommission + fixedFee;
                    }
                  }
                }
                return mergedCoAgent;
              });
            }
          }
        }

        // If we have co-agents, set primary agent split to 50%, otherwise 100%
        const hasCoAgents = deal.co_listing_agents && deal.co_listing_agents.length > 0;
        
        // Only set default split if not already present
        if (deal.primary_agent_commission_split === null || deal.primary_agent_commission_split === undefined) {
          deal.primary_agent_commission_split = hasCoAgents ? 50 : 100;
        }

        let sourceLabelForState = getSource(deal.source);
        if (deal.source === 'other') {
          sourceLabelForState = 'Others'; // Ensure 'Others' label for 'other' value
        }

        this.setState({
          form: {
            ...form,
            ...deal,
            skyslope_unique_id: deal.skyslope_unique_id || deal.audit_custom_unique_id || "",
            primary_agent_reported_income: this.truncateToTwoDecimals(deal.primary_agent_reported_income),
            primary_agent_net_commission: this.truncateToTwoDecimals(deal.primary_agent_net_commission),
            primary_agent_misc_fees: this.truncateToTwoDecimals(deal.primary_agent_misc_fees),
            schedule_sign_post_installation: {
              label: deal.schedule_sign_post_installation && deal.schedule_sign_post_installation === 0 ? "No" : "Yes",
              value: deal.schedule_sign_post_installation,
            },
            client_type: {
              label: this.getLabel(deal.client_type && deal.client_type.replaceAll("_", " ")),
              value: deal.client_type,
            },
            source: {
              // label: getSource(deal.source),
              label: sourceLabelForState,
              value: deal.source,
            },
            transaction_type: {
              label: this.getLabelFromObj(deal.transaction_type, TRANSACTION_TYPE),
              value: deal.transaction_type,
            },
            file_type: {
              label: this.getLabel(deal.file_type && deal.file_type.replaceAll("_", " ")),
              value: deal.file_type,
            },
            is_radius_lead: {
              label: deal.is_radius_lead && deal.is_radius_lead === 0 ? "No" : "Yes",
              value: deal.is_radius_lead,
            },
            radius_transaction_type: {
              label: deal.radius_transaction_type && deal.radius_transaction_type,
              value: deal.radius_transaction_type,
            },
            commission_type: {
              label: this.getLabel(deal.commission_type && deal.commission_type.replaceAll("_", " ")),
              value: deal.commission_type,
            },
            representing_broker_commission_type: deal.representing_broker_commission_type
              ? {
                label: this.getLabel(deal.representing_broker_commission_type && deal.representing_broker_commission_type.replaceAll("_", " ")),
                value: deal.representing_broker_commission_type,
              }
              : null,
            active_listing_status: {
              label: this.getLabel(deal.active_listing_status && deal.active_listing_status.replaceAll("_", " ")),
              value: deal.active_listing_status,
            },
            is_all_cash_offer: {
              label: deal.is_all_cash_offer === 0 ? "No" : "Yes",
              value: deal.is_all_cash_offer,
            },
            is_using_deal_tc: {
              label: deal.is_using_deal_tc === 1 ? "Yes" : "No",
              value: deal.is_using_deal_tc,
            },
            is_radius_tc_to_open_escrow: {
              label: deal.is_radius_tc_to_open_escrow !== null && deal.is_radius_tc_to_open_escrow === 1 ? "Yes" : "No",
              value: deal.is_radius_tc_to_open_escrow !== null && deal.is_radius_tc_to_open_escrow === 1 ? 1 : 0,
            },
            rent_amount_term: {
              label: this.getLabel(deal.rent_amount_term && deal.rent_amount_term.replaceAll("_", " ")),
              value: deal.rent_amount_term,
            },
            clients: this.depricateClient(deal),
            co_listing_agents: deal.co_listing_agents || [],
            primary_agent_commission_split: deal.primary_agent_commission_split,
          },
          isEdit: !!deal,
          hasChangedSplits: true, // Mark as already set so we don't override existing values
          hasChangedRepresentingBrokerGrossCommission: false,
        }, () => {
          // Calculate radius fees for all co-agents to ensure they're initialized properly
          this.calculateAllCoAgentRadiusFees();
          
          // RB gross must apply before referral gross commission reads it; defer avoids stale state / setState clobbering.
          this.calculateRepresentingBrokerGrossCommission();
          setTimeout(() => {
            this.calculateGrossCommission();
          }, 0);

          // Calculate radius transaction fee for primary agent
          const newFormState = this.state.form;
          const radiusTransactionFee = parseFloat(([
            newFormState.brokerage_fee || 0,
            // newFormState.agent_payout_fee || 0,
            newFormState.tc_fee || 0,
            newFormState.audit_fee || 0,
            newFormState.pending_subscription_fee || 0,
            newFormState.e_and_o_fee || 0,
            newFormState.referral_fee || 0
          ].reduce((acc, curr) => acc + (curr ? Number(curr) : Number(0)), 0)).toFixed(2));
          
          // Only update if different from current value
          if (newFormState.radius_transaction_fee !== radiusTransactionFee) {
            this.setState({
              form: {
                ...newFormState,
                radius_transaction_fee: radiusTransactionFee
              }
            });
          }
        });
      }
    } else {
      // For new deals, set primary agent commission split to 100% by default
      this.setState({
        form: {
          ...form,
          primary_agent_commission_split: 100,
          total_primary_agent_commission: this.getGrossCommissionAfterDeductions(), // Initialize total based on 100% split
        },
        hasChangedSplits: false
      });
    }
    
    //here
    if (location.search && location.search.includes("checkPricing=true")) {
      setTimeout(() => {
        this.setState({
          animatePricing: true,
        })
      }, 500)
      setTimeout(() => {
        const $ele = document.getElementById("tc-pricing-section")
        if ($ele) {
          $ele.scrollIntoView(false)
        }
      }, 1000)
    }
  }

  getTransactionTypeLabel = (value) => {
    const str = value?.value;
    if (!str || typeof str !== "string") return "";
  
    const formatted = str
      .replaceAll("_", " ") // replace underscores
      .replace(/^\w/, (c) => c.toUpperCase()); // capitalize first letter
  
    return formatted;
  };

  getLabel = (value) => {
    if (value === "created_at") {
      return "Acceptance Date"
    }
    if (value === "payment_initiated") {
      return "Agent/Partner Payment Initiated"
    }
    return value && value.replace(value[0], value[0]
      .toUpperCase())
      .replaceAll("_", " ")
  }

  getLabelFromObj = (value, list) => {
    const selectedItem = list.filter(x => x.value === value)
    return selectedItem.length > 0 ? selectedItem[0].label : value
  }

  // Back-fills firstname/lastname for clients persisted before the name field was split in two
  splitClientName = (client = {}) => {
    if (client.firstname !== undefined || client.lastname !== undefined) {
      return client
    }
    const [firstname = "", ...rest] = (client.name || "").trim().split(/\s+/).filter(Boolean)
    return {
      ...client,
      firstname,
      lastname: rest.join(" "),
    }
  }

  depricateClient = (deal = {}) => {
    // Index 0 is marked is_primary on save, so surface the client
    // matching the deal-level client_type first
    const newClient = orderClientsByDealType(deal.clients || [], deal.client_type)
    if (
      deal.client_email
      && deal.client_name
    ) {
      return [{
        email: deal.client_email,
        name: deal.client_name,
        client_id: null,
        phone: null,
        is_primary: null,
      },
      ...newClient,
      ].map(this.splitClientName)
    }
    return newClient.map(this.splitClientName)
  }

  handleChange = (event, formateFn) => {
    const { form } = this.state
    const { name, value } = event.target
    const amountToRoundOff = ["price", "list_price", "rent_amount", "fixed_fee", "gross_commission", "agent_commission", "commission_deductions", "representing_broker_commission_fixed_fee", "representing_broker_gross_commission", "representing_broker_commission_deductions"]; // Added commission_deductions
    
    // Track if specific fields are being changed
    if (name === "gross_commission") {
      this.setState({ hasChangedGrossCommission: true });
    } else if (name === "brokerage_net_commission") {
      this.setState({ hasChangedBrokerageNetCommission: true });
    } else if (name === "representing_broker_gross_commission") {
      this.setState({ hasChangedRepresentingBrokerGrossCommission: true });
    }
    
    if (amountToRoundOff.includes(name)){
      const check_value = value.toString().replace(/(\.\d{2}).*/, '$1')
      this.setState({
        form: {
          ...form,
          [name]: formateFn ? formateFn(check_value) : check_value,
        },
      }, () => {
        // Auto-calculate gross commission when price or commission percentage changes
        if (name === "price" || name === "commision_percentage" || name === "fixed_fee") {
          this.calculateGrossCommission();
        }
        if (name === "representing_broker_gross_commission" || name === "representing_broker_commission_deductions") {
          this.calculateGrossCommission();
        }
        if (name === "price" || name === "rent_amount" || name === "representing_broker_commission_fixed_fee") {
          this.calculateRepresentingBrokerGrossCommission();
        }
      })
    } else{
      this.setState({
        form: {
          ...form,
          [name]: formateFn ? formateFn(value) : value,
        },
      }, () => {
        // Auto-calculate gross commission when price or commission percentage changes
        if (name === "price" || name === "commision_percentage" || name === "fixed_fee") {
          this.calculateGrossCommission();
        }
        if (name === "price" || name === "rent_amount" || name === "representing_broker_commission_percentage" || name === "representing_broker_commission_fixed_fee") {
          this.calculateRepresentingBrokerGrossCommission();
        }
      })
    }
  }

  // Add a new method to calculate gross commission
  calculateGrossCommission = () => {
    const { form } = this.state;
    
    // Check if user has manually edited the gross commission
    if (this.state.hasChangedGrossCommission) {
      return;
    }

    const clientType = isObject(form.client_type) ? form.client_type.value : form.client_type;
    // Referral: main Commission % × gross commission after deductions (representing broker) → Gross commission field
    if (clientType === "referral") {
      const rbGross = typeof form.representing_broker_gross_commission === "number"
        ? form.representing_broker_gross_commission
        : parseFloat(String(form?.representing_broker_gross_commission || "").replace(/[^0-9.-]/g, "")) || 0;
      const rbDed = typeof form.representing_broker_commission_deductions === "number"
        ? form.representing_broker_commission_deductions
        : parseFloat(String(form?.representing_broker_commission_deductions || "").replace(/[^0-9.-]/g, "")) || 0;
      const rbAfterDed = rbGross - rbDed;
      const commissionPct = parseFloat(form.commision_percentage);
      if (!isNaN(commissionPct)) {
        const grossCommission = ((commissionPct / 100) * rbAfterDed).toFixed(2);
        if (form.gross_commission !== grossCommission) {
          this.setState(prevState => ({
            form: {
              ...prevState.form,
              gross_commission: grossCommission,
            },
          }));
        }
      }
      return;
    }
    
    // Commission is based on either percentage or fixed fee depending on commission type
    const commissionType = form.commission_type && isObject(form.commission_type) ? 
      form.commission_type.value : form.commission_type;
    
    if (commissionType === "percentage" && form.price && form.commision_percentage) {
      // Parse the values (handle the case where price might be formatted with commas or currency symbols)
      const price = typeof form.price === 'string' ? 
        parseFloat(form.price.replace(/[^0-9.]/g, '')) : 
        parseFloat(form.price);
      
      const commissionPercentage = parseFloat(form.commision_percentage);
      
      // Only proceed if both values are valid numbers
      if (!isNaN(price) && !isNaN(commissionPercentage)) {
        // Calculate gross commission (price * commission percentage / 100)
        const grossCommission = (price * commissionPercentage / 100).toFixed(2);
        
        // Only update if the calculated value is different from the current value
        if (form.gross_commission !== grossCommission) {
          this.setState(prevState => ({
            form: {
              ...prevState.form,
              gross_commission: grossCommission,
            },
          }));
        }
      }
    } else if (commissionType === "fixed_fee" && form.fixed_fee) {
      // For fixed fee, the gross commission is just the fixed fee
      const fixedFee = typeof form.fixed_fee === 'string' ?
        parseFloat(form.fixed_fee.replace(/[^0-9.]/g, '')) :
        parseFloat(form.fixed_fee);
        
      if (!isNaN(fixedFee)) {
        const grossCommission = fixedFee.toFixed(2);
        
        if (form.gross_commission !== grossCommission) {
          this.setState(prevState => ({
            form: {
              ...prevState.form,
              gross_commission: grossCommission,
            },
          }));
        }
      }
    } else if (commissionType === "both" && form.price && form.commision_percentage && form.fixed_fee) {
      // For "both", add the percentage commission and fixed fee
      const price = typeof form.price === 'string' ? 
        parseFloat(form.price.replace(/[^0-9.]/g, '')) : 
        parseFloat(form.price);
      
      const commissionPercentage = parseFloat(form.commision_percentage);
      
      const fixedFee = typeof form.fixed_fee === 'string' ?
        parseFloat(form.fixed_fee.replace(/[^0-9.]/g, '')) :
        parseFloat(form.fixed_fee);
      
      if (!isNaN(price) && !isNaN(commissionPercentage) && !isNaN(fixedFee)) {
        const percentageCommission = price * commissionPercentage / 100;
        const grossCommission = (percentageCommission + fixedFee).toFixed(2);
        
        if (form.gross_commission !== grossCommission) {
          this.setState(prevState => ({
            form: {
              ...prevState.form,
              gross_commission: grossCommission,
            },
          }));
        }
      }
    }
  }

  getRepresentingBrokerPriceBase = () => {
    const { form } = this.state;
    const parseMoney = (raw) => {
      if (raw === null || raw === undefined || raw === "") return null;
      const n = typeof raw === "string" ? parseFloat(raw.replace(/[^0-9.]/g, "")) : parseFloat(raw);
      return isNaN(n) ? null : n;
    };
    const fileType = form.file_type && isObject(form.file_type) ? form.file_type.value : form.file_type;
    if (fileType === "lease_listing" || fileType === "pending_lease") {
      const rent = parseMoney(form.rent_amount);
      if (rent !== null) return rent;
    }
    return parseMoney(form.price);
  }

  calculateRepresentingBrokerGrossCommission = () => {
    const { form } = this.state;
    const clientType = isObject(form.client_type) ? form.client_type.value : form.client_type;
    if (clientType !== "referral") {
      return;
    }
    if (this.state.hasChangedRepresentingBrokerGrossCommission) {
      return;
    }
    const commissionType = form.representing_broker_commission_type && isObject(form.representing_broker_commission_type)
      ? form.representing_broker_commission_type.value
      : form.representing_broker_commission_type;
    const basePrice = this.getRepresentingBrokerPriceBase();

    if (commissionType === "percentage" && basePrice && form.representing_broker_commission_percentage) {
      const commissionPercentage = parseFloat(form.representing_broker_commission_percentage);
      if (!isNaN(basePrice) && !isNaN(commissionPercentage)) {
        const grossCommission = (basePrice * commissionPercentage / 100).toFixed(2);
        if (form.representing_broker_gross_commission !== grossCommission) {
          this.setState(prevState => ({
            form: {
              ...prevState.form,
              representing_broker_gross_commission: grossCommission,
            },
          }));
        }
      }
    } else if (commissionType === "fixed_fee" && form.representing_broker_commission_fixed_fee) {
      const fixedFee = typeof form.representing_broker_commission_fixed_fee === "string"
        ? parseFloat(form.representing_broker_commission_fixed_fee.replace(/[^0-9.]/g, ""))
        : parseFloat(form.representing_broker_commission_fixed_fee);
      if (!isNaN(fixedFee)) {
        const grossCommission = fixedFee.toFixed(2);
        if (form.representing_broker_gross_commission !== grossCommission) {
          this.setState(prevState => ({
            form: {
              ...prevState.form,
              representing_broker_gross_commission: grossCommission,
            },
          }));
        }
      }
    } else if (commissionType === "both" && basePrice && form.representing_broker_commission_percentage && form.representing_broker_commission_fixed_fee) {
      const commissionPercentage = parseFloat(form.representing_broker_commission_percentage);
      const fixedFee = typeof form.representing_broker_commission_fixed_fee === "string"
        ? parseFloat(form.representing_broker_commission_fixed_fee.replace(/[^0-9.]/g, ""))
        : parseFloat(form.representing_broker_commission_fixed_fee);
      if (!isNaN(basePrice) && !isNaN(commissionPercentage) && !isNaN(fixedFee)) {
        const percentageCommission = basePrice * commissionPercentage / 100;
        const grossCommission = (percentageCommission + fixedFee).toFixed(2);
        if (form.representing_broker_gross_commission !== grossCommission) {
          this.setState(prevState => ({
            form: {
              ...prevState.form,
              representing_broker_gross_commission: grossCommission,
            },
          }));
        }
      }
    }
  }

  handleChangeNumber = (value, name) => {
    const { form } = this.state
    
    // For primary_agent_misc_fees, allow normal editing without truncation
    let check_value;
    if (name === "primary_agent_misc_fees") {
      check_value = value || null;
    } else {
      check_value = Math.round(value * 100) / 100;
    }
    
    // Track if specific fields are being changed
    if (name === "gross_commission") {
      this.setState({ hasChangedGrossCommission: true });
    } else if (name === "brokerage_net_commission") {
      this.setState({ hasChangedBrokerageNetCommission: true });
    } else if (name === "representing_broker_gross_commission") {
      this.setState({ hasChangedRepresentingBrokerGrossCommission: true });
    }
    
    this.setState({
      form: {
        ...form,
        [name]: check_value,
      },
    },
    () => {
      const { form: newFormState } = this.state
      
      const radiusTransactionFee = parseFloat(([
        newFormState.brokerage_fee,
        // newFormState.agent_payout_fee,
        newFormState.tc_fee,
        newFormState.audit_fee,
        newFormState.pending_subscription_fee,
        newFormState.e_and_o_fee,
        newFormState.referral_fee
      ].reduce((acc, curr) => acc + (curr ? Number(curr) : Number(0)), 0)).toFixed(2));
      this.setState({
        form: {
          ...newFormState,
          radius_transaction_fee: radiusTransactionFee
        },
      })
      
    })
  }

  handleContributionToCapManualChange = (value) => {
    const { form } = this.state;
    const normalizedValue = value === null || value === undefined || value === "" ? null : Number(value);
    this.setState({
      form: {
        ...form,
        contribution_to_internal_cap_manual: Number.isNaN(normalizedValue) ? null : normalizedValue,
      },
    });
  }

  handleCoAgentContributionToCapManualChange = (agentIndex, value) => {
    const normalizedValue = value === null || value === undefined || value === "" ? null : Number(value);
    this.setState(prevState => ({
      form: {
        ...prevState.form,
        co_listing_agents: (prevState.form.co_listing_agents || []).map((agent, idx) => (
          idx === agentIndex
            ? {
              ...agent,
              contribution_to_internal_cap_manual: Number.isNaN(normalizedValue) ? null : normalizedValue,
            }
            : agent
        )),
      },
    }));
  }

  formatter = (value) => {
    const check_value = Number(value)
    if (value) {
      return `${parseFloat(check_value).toFixed(2)}`;
    }
    return 
  };

  boolCheck = (field) => {
    if (isObject(field)) {
      return field.value
    }
    return field
  }

  createDeals = () => {
    const {
      createDeals,
      history,
      match,
      createVendorDetails,
      allVendors,
      updateVendorDetails,
      selectVendorDetails,
      selectedId,
      setIsCreatingDeal,
      isCreatingDeal,
    } = this.props
    const { 
      form, 
      selectedAgent, 
      isEdit, 
      isSelected, 
      localArr,
      hasChangedBrokerageNetCommission,
      hasChangedGrossCommission
    } = this.state
    
    // --- START: Property Details Validation ---
    const newErrorFields = { ...this.state.errorFields };
    let propertyDetailsMissing = false;
    const missingPropertyFields = [];

    if (!form.listing_address) {
      newErrorFields.listing_address = true;
      propertyDetailsMissing = true;
      missingPropertyFields.push("Address");
    } else {
      newErrorFields.listing_address = false;
    }

    if (!form.city) {
      newErrorFields.city = true;
      propertyDetailsMissing = true;
      missingPropertyFields.push("City");
    } else {
      newErrorFields.city = false;
    }

    if (!form.state) {
      newErrorFields.state = true;
      propertyDetailsMissing = true;
      missingPropertyFields.push("State");
    } else {
      newErrorFields.state = false;
    }

    if (!form.zipcode) {
      newErrorFields.zipcode = true;
      propertyDetailsMissing = true;
      missingPropertyFields.push("Zip Code");
    } else {
      newErrorFields.zipcode = false;
    }

    if (propertyDetailsMissing) {
      this.setState({ errorFields: newErrorFields });
      setIsCreatingDeal(false);
      toast.error(
        `Please fill missing Property Details: ${missingPropertyFields.join(", ")}`,
        {
          position: "top-center",
          hideProgressBar: true,
        }
      );
      return;
    }
    // --- END: Property Details Validation ---
    
    // Update misc_fee_amounts from localArr before creating the payload
    // Filter out zero values
    const nonZeroValues = localArr.filter(value => value !== 0);
    if (nonZeroValues.length > 0) {
      form.misc_fee_amounts = nonZeroValues.join(' | ');
    } else {
      form.misc_fee_amounts = "";
    }
    
    setIsCreatingDeal(true)
    const dealId = get(match, "params.dealId")
    if (!(selectedAgent || get(match, "params.agentId"))) {
      this.setState({
        isAgentNotSelected: true,
      })
      setIsCreatingDeal(false)
      return
    }
    const agentId = get(match, "params.agentId")

    const formkeys = Object.keys(form)
    const ignoredFields = [
      "client_email",
      "client_name",
      "agent_commission",
      "gross_commission",
      "is_radius_lead",
      "contract_on",
      "co_listing_agents",
      "lender_email_address",
      "schedule_sign_post_installation",
      "hoa_guidelines",
      "agent_id",
      "other_source",
      "other_transaction_type",
      "rent_amount_term",
      "rent_amount",
      "other_rent_amount_term",
      "is_using_radius_tc",
      "is_using_deal_tc",
      "is_coupon_applied",
      "is_radius_tc_to_open_escrow",
      "agent_type",
      "confirmed_closed_on",
      "agent_phone",
      "agent_email",
      "agent_lastname",
      "active_listing_status",
      "commission_demand_url",
      "tc_calendly_links",
      "tc_email",
      "tc_firstname",
      "tc_lastname",
      "tc_phone",
      "tc_profile_image",
      "assigned_tc_id",
      "escrow_officer_email",
      "escrow_officer_phone",
      "active_state_served",
      "radius_transaction_type",
      "deal_status",
      "skyslope_unique_id",
    ]

    const replaceFieldErrorField = {
      closed_on: "est._closing_on",
    }

    const user = cookie.load("user")

    const removeListForComplexDataTypes = [
      "completed_steps",
    ]

    if (dealId) {
      const completedStepIndex = formkeys.indexOf("completed_steps")
      formkeys.splice(completedStepIndex, 1)
    }

    const fileType = get(form, "file_type.value")

    if (fileType === "new_listing") {
      ignoredFields.push("price")
      ignoredFields.push("created_at")
      ignoredFields.push("lease_commencement_on")
      ignoredFields.push("escrow_officer_email")
      ignoredFields.push("closed_on")
      ignoredFields.push("row_created_at")
      ignoredFields.push("is_radius_tc_to_open_escrow")
      ignoredFields.push("vendor_id")
    } else {
      // other than new listing
      ignoredFields.push("sign_post_installation_on")
      ignoredFields.push("sign_post_installation_riders")
      ignoredFields.push("sign_post_installation_location")
      ignoredFields.push("listing_date")
      ignoredFields.push("listing_expiration_date")
      ignoredFields.push("date_of_listing_submission")
    }

    if (form.is_using_deal_tc !== null && form.is_using_deal_tc.value === 1) {
      ignoredFields.push("tc_name")
      ignoredFields.push("tc_email")
      ignoredFields.push("tc_phone")
    }

    if (fileType === "pending_contract"
      || fileType === "lease_listing"
      || fileType === "pending_lease"
      || fileType === "external_referral_agreement"
    ) {
      ignoredFields.push("list_price")
    }

    if (form.is_all_cash_offer === 1) {
      ignoredFields.push("lender_email_address")
    }

    if (form.schedule_sign_post_installation && form.schedule_sign_post_installation.value === 0) {
      ignoredFields.push("sign_post_installation_on")
      ignoredFields.push("sign_post_installation_riders")
      ignoredFields.push("sign_post_installation_location")
    }

    if (fileType === "lease_listing" || fileType === "pending_lease") {
      ignoredFields.push("price")
    }

    if (fileType === "new_listing"
      || fileType === "listing_with_accepted_offer"
      || fileType === "pending_lease"
      || fileType === "lease_listing"
    ) {
      ignoredFields.push("escrow_officer_email")
      ignoredFields.push("escrow_officer_phone")
      ignoredFields.push("is_radius_tc_to_open_escrow")
      ignoredFields.push("lease_commencement_on")
    }

    if (fileType === "new_listing"
      || fileType === "listing_with_accepted_offer"
      || fileType === "dual"
      || fileType === "external_referral_agreement"
      || fileType === "pending_contract"
    ) {
      ignoredFields.push("lease_commencement_on")
    }

    if (fileType === "") {
      ignoredFields.push("escrow_officer_phone")
    }

    if ((form.file_type
      && form.file_type.value !== "external_referral_agreement")
      || (form.commission_type && form.commission_type.value === "fixed_fee")
    ) {
      ignoredFields.push("closing_agent_commision_percentage")
    }

    // if (form.commission_type && form.commission_type.value === "fixed_fee") {
    //   ignoredFields.push("closing_agent_commision_percentage")
    // }

    if ((form.is_radius_tc_to_open_escrow && form.is_radius_tc_to_open_escrow.value === 0) || (form.is_using_deal_tc !== null && form.is_using_deal_tc.value === 0)) {
      ignoredFields.push("escrow_officer_phone")
      ignoredFields.push("escrow_officer_email")
      ignoredFields.push("is_radius_tc_to_open_escrow")
      ignoredFields.push("vendor_id")
    }

    if (form.commission_type && form.commission_type.value === "fixed_fee") {
      ignoredFields.push("commision_percentage")
    }

    if (form.commission_type && form.commission_type.value === "percentage") {
      ignoredFields.push("fixed_fee")
    }

    const clientTypeValForIgnore = isObject(form.client_type) ? form.client_type.value : form.client_type
    if (clientTypeValForIgnore !== "referral") {
      ignoredFields.push("representing_broker_commission_type", "representing_broker_commission_percentage", "representing_broker_commission_fixed_fee", "representing_broker_gross_commission", "representing_broker_commission_deductions", "representing_broker_gross_commission_after_deductions")
    } else {
      ignoredFields.push("representing_broker_gross_commission_after_deductions")
      if (form.representing_broker_commission_type && form.representing_broker_commission_type.value === "fixed_fee") {
        ignoredFields.push("representing_broker_commission_percentage")
      }
      if (form.representing_broker_commission_type && form.representing_broker_commission_type.value === "percentage") {
        ignoredFields.push("representing_broker_commission_fixed_fee")
      }
    }

    // Check for Clients data
    if (!form.clients || (form.clients && form.clients.length === 0)) {
      setIsCreatingDeal(false)
      toast.error(
        "Please fill missing Client Details", {
          position: "top-center",
          hideProgressBar: true,
        }
      )
      return
    }

    // Gross commission after deductions always tracks gross commission − commission deductions (referral gross is derived into gross_commission separately).
    const grossCommissionValue = this.parseMoneyField(form.gross_commission);
    const commissionDeductionsValue = this.parseMoneyField(form.commission_deductions);
    const calculatedGrossCommissionAfterDeductions = grossCommissionValue - commissionDeductionsValue;

    if (calculatedGrossCommissionAfterDeductions < 0) {
      setIsCreatingDeal(false); // Re-enable button
      toast.error(
        "Gross commission after deductions cannot be negative. Please adjust commission or deductions.", {
          position: "top-center",
          hideProgressBar: true,
        }
      );
      return;
    }

    const clientTypeValReferral = isObject(form.client_type) ? form.client_type.value : form.client_type
    if (clientTypeValReferral === "referral") {
      const rbPctVal = parseFloat(form.representing_broker_commission_percentage) || 0
      const rbFixedRaw = form.representing_broker_commission_fixed_fee
      const rbFixedVal = rbFixedRaw === null || rbFixedRaw === undefined || rbFixedRaw === ""
        ? 0
        : (typeof rbFixedRaw === "number" ? rbFixedRaw : parseFloat(String(rbFixedRaw).replace(/[^0-9.-]/g, "")) || 0)
      const rbTypeVal = isObject(form.representing_broker_commission_type) ? form.representing_broker_commission_type.value : form.representing_broker_commission_type
      const rbInputsOk = rbTypeVal === "percentage" ? rbPctVal > 0
        : rbTypeVal === "fixed_fee" ? rbFixedVal > 0
          : rbTypeVal === "both" ? (rbPctVal > 0 || rbFixedVal > 0)
            : rbPctVal > 0 || rbFixedVal > 0
      if (!rbInputsOk) {
        setIsCreatingDeal(false)
        toast.error(
          "For referral deals, complete representing broker commission for the type you selected. For \"Both\", enter at least a percentage or a fixed dollar amount.",
          {
            position: "top-center",
            hideProgressBar: true,
          },
        )
        return
      }
      const rbGrossVal = typeof form.representing_broker_gross_commission === "number"
        ? form.representing_broker_gross_commission
        : parseFloat(String(form.representing_broker_gross_commission || "").replace(/[^0-9.-]/g, "")) || 0
      const rbDedVal = typeof form.representing_broker_commission_deductions === "number"
        ? form.representing_broker_commission_deductions
        : parseFloat(String(form.representing_broker_commission_deductions || "").replace(/[^0-9.-]/g, "")) || 0
      if (rbGrossVal - rbDedVal < 0) {
        setIsCreatingDeal(false)
        toast.error(
          "Representing broker gross commission after deductions cannot be negative.",
          {
            position: "top-center",
            hideProgressBar: true,
          },
        )
        return
      }
    }

    // Validate total commission split (co-agent split UI is hidden for referral client type)
    if (clientTypeValReferral !== "referral") {
      let totalSplitPercentage = Number(form.primary_agent_commission_split) || 0;
      if (form.co_listing_agents && form.co_listing_agents.length > 0) {
        form.co_listing_agents.forEach(agent => {
          totalSplitPercentage += Number(agent.commission_split) || 0;
        });
      }

      if (totalSplitPercentage !== 100) {
        setIsCreatingDeal(false);
        toast.error(
          "Total commission split between primary and co-agents must equal 100%.", {
            position: "top-center",
            hideProgressBar: true,
          }
        );
        return; // Halt submission
      }
    }

    if (form.co_listing_agents && form.co_listing_agents.length > 0) {
      const agentType = isObject(form.client_type) ? form.client_type.value : form.client_type
      for (let i = 0; i < form.co_listing_agents.length; i++) {
        form.co_listing_agents[i].agent_type = agentType
      }
    }

    if (form.clients && form.clients.length > 0) {
      let isClientError = false
      let isOtherSourceError = false
      for (const client of form.clients) {
        // Client name/email are optional; a source is required per client
        // (either selected on the client itself or the deal-level source)
        if (!client.source && !form.source) {
          isClientError = true
        }
        // An "other" source is only meaningful alongside the free-text description of it.
        // Clients without their own source inherit the deal-level source and its free text.
        const effectiveSource = client.source || (isObject(form.source) ? form.source.value : form.source)
        const effectiveOtherSource = client.source ? client.other_source : form.other_source
        if (isOtherSource(effectiveSource) && !(effectiveOtherSource || "").trim()) {
          isOtherSourceError = true
        }
      }
      if (isClientError) {
        setIsCreatingDeal(false)
        toast.error(
          "Please select a Source for each client", {
            position: "top-center",
            hideProgressBar: true,
          }
        )
        return
      }
      if (isOtherSourceError) {
        setIsCreatingDeal(false)
        toast.error(
          "Please enter the Other Client Source for each client with source \"Other\"", {
            position: "top-center",
            hideProgressBar: true,
          }
        )
        return
      }
      // is_primary is scoped per client_type (e.g. the first buyer is primary among buyers,
      // the first seller is primary among sellers) rather than one flag for the whole array,
      // since a deal can represent both sides at once and each side needs its own primary contact.
      const seenClientTypes = new Set()
      for (let i = 0; i < form.clients.length; i++) {
        form.clients[i].client_type = form.clients[i].client_type
          || (isObject(form.client_type) ? form.client_type.value : form.client_type)
        const clientType = form.clients[i].client_type
        form.clients[i].is_primary = seenClientTypes.has(clientType) ? 0 : 1
        seenClientTypes.add(clientType)
        if (!form.clients[i].source) {
          // Falling back to the deal-level source carries its free-text value along,
          // since an "other" source is meaningless without one
          form.clients[i].source = isObject(form.source) ? form.source.value : form.source
          if (isOtherSource(form.clients[i].source)) {
            form.clients[i].other_source = form.other_source
          }
        }
        if (!isOtherSource(form.clients[i].source)) {
          form.clients[i].other_source = null
        }
        if (!((form.clients[i].email || "").match(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/))) {
          form.clients[i].email = "na"
        }
      }
    }
    const errorKeys = formkeys.filter((key) => {
      // Only check for keys which are Not ignored
      if (ignoredFields.indexOf(key) === -1) {
        if (isArray(form[key]) && form[key].length === 0) {
          return true
        } if (form[key] === "") {
          return true
        } if (form[key] === null) {
          return true
        }
        return false
      }
    })

    if (form.closed_on === null) {
      setIsCreatingDeal(false)
      toast.error(
        "Please fill the Estimated Closing Date", {
          position: "top-center",
          hideProgressBar: true,
        }
      )
      return
    }
    
    // Create a copy of the form object without fields that are handled specially or derived in the payload
    const {
      gross_commission,
      brokerage_net_commission,
      gross_commission_after_deductions, // Exclude this as we will use the calculated value
      representing_broker_gross_commission,
      representing_broker_commission_deductions,
      representing_broker_gross_commission_after_deductions,
      ...formWithoutCommission
    } = form;
    const totals = this.calculateTotals();
    const rbGrossPayload = typeof representing_broker_gross_commission === "number"
      ? representing_broker_gross_commission
      : parseFloat(String(representing_broker_gross_commission || "").replace(/[^0-9.-]/g, "")) || 0
    const rbDedPayload = typeof representing_broker_commission_deductions === "number"
      ? representing_broker_commission_deductions
      : parseFloat(String(representing_broker_commission_deductions || "").replace(/[^0-9.-]/g, "")) || 0
    const rbFixedForPayload = form.representing_broker_commission_fixed_fee
    const rbFixedPayload = rbFixedForPayload === null || rbFixedForPayload === undefined || rbFixedForPayload === ""
      ? null
      : (typeof rbFixedForPayload === "number" ? rbFixedForPayload : parseFloat(String(rbFixedForPayload).replace(/[^0-9.-]/g, "")))
    const rbPctPayload = form.representing_broker_commission_percentage === "" || form.representing_broker_commission_percentage === null || form.representing_broker_commission_percentage === undefined
      ? null
      : Number(form.representing_broker_commission_percentage)
    // console.log("before payload", form.agents_info[form.agents_info.findIndex(a => a.is_primary === 0)])
    // const primaryAgent = form?.agents_info?.find(agent => agent.is_primary === 0) || {}; // Removed complex merge for multiple agents
    // const overrideData = Array.isArray(form?.co_listing_agents) && form?.co_listing_agents?.length > 0 
    //   ? form?.co_listing_agents[0] 
    //   : {};

    // const mergedCoListingAgent = { // Removed complex merge for multiple agents
    //   ...primaryAgent,
    //   ...overrideData,
    //   team_split_type: overrideData.team_split_type || (form.team_split_type && isObject(form.team_split_type) ? form.team_split_type.value : form.team_split_type),
    //   recievable_status: overrideData.recievable_status && isObject(overrideData.recievable_status) ? 
    //     overrideData.recievable_status.value : 
    //     overrideData.recievable_status
    // };
    const payload = {
      ...formWithoutCommission,
      client_email: "",
      client_name: "",
      commision_percentage: Number(form.commision_percentage),
      closing_agent_commision_percentage: Number(form.closing_agent_commision_percentage),
      // Only include these fields if they've been changed
      ...(hasChangedGrossCommission ? { gross_commission: Number(gross_commission) } : {}),
      new_referral_fee: Number(form.new_referral_fee),
      ...(hasChangedBrokerageNetCommission ? { brokerage_net_commission: Number(brokerage_net_commission) } : {}),
      gross_commission: Number(gross_commission),
      gross_commission_after_deductions: Number(calculatedGrossCommissionAfterDeductions), // Use the calculated value
      commission_deductions: Number(form.commission_deductions),
      agent_commission: Number(form.agent_commission),
      rent_amount: Number(form.rent_amount),
      radius_transaction_fee: Number(form.radius_transaction_fee),
      brokerage_fee: Number(form.brokerage_fee),
      agent_payout_fee: Number(form.agent_payout_fee),
      tc_fee: Number(form.tc_fee),
      audit_fee: Number(form.audit_fee),
      pending_subscription_fee: Number(form.pending_subscription_fee),
      e_and_o_fee: Number(form.e_and_o_fee),
      referral_fee: Number(form.referral_fee),
      price: form.price && Number(form.price) || null,
      agent_id: (selectedAgent && selectedAgent.id) || Number(get(match, "params.agentId")),
      client_type: isObject(form.client_type) ? form.client_type.value : form.client_type,
      source: isObject(form.source) ? form.source.value : form.source,
      list_price: Number(form.list_price),
      file_type: isObject(form.file_type) ? form.file_type.value : form.file_type,
      is_all_cash_offer: isObject(form.is_all_cash_offer) ? form.is_all_cash_offer.value : form.is_all_cash_offer,
      is_using_deal_tc: isObject(form.is_using_deal_tc) ? form.is_using_deal_tc.value : form.is_using_deal_tc,
      transaction_type: isObject(form.transaction_type) ? form.transaction_type.value : form.transaction_type,
      // zipcode: Math.floor(form.zipcode),
      zipcode: form.zipcode,
      commission_type: isObject(form.commission_type) ? form.commission_type.value : form.commission_type,
      representing_broker_commission_type: isObject(form.representing_broker_commission_type) ? form.representing_broker_commission_type.value : form.representing_broker_commission_type,
      representing_broker_commission_percentage: rbPctPayload,
      representing_broker_commission_fixed_fee: rbFixedPayload === null || isNaN(rbFixedPayload) ? null : rbFixedPayload,
      representing_broker_gross_commission: rbGrossPayload,
      representing_broker_commission_deductions: rbDedPayload,
      representing_broker_gross_commission_after_deductions: rbGrossPayload - rbDedPayload,
      primary_agent_misc_fees: Number(form.primary_agent_misc_fees), 
      primary_agent_commission_type: isObject(form.primary_agent_commission_type) ? form.primary_agent_commission_type.value : form.primary_agent_commission_type,
      team_split_percentage: Number(form.team_split_percentage),
      team_split_type: isObject(form.team_split_type) ? form.team_split_type.value : form.team_split_type,
      is_radius_lead: isObject(form.is_radius_lead) ? form.is_radius_lead.value : form.is_radius_lead,
      fixed_fee: Number(form.fixed_fee),
      primary_agent_fixed_fee: Number(form.primary_agent_fixed_fee),
      primary_agent_commission_split: Number(form.primary_agent_commission_split),
      team_split_fixed_fee: Number(form.team_split_fixed_fee),
      active_listing_status: isObject(form.active_listing_status) ? form.active_listing_status.value : form.active_listing_status || "active_listing",
      is_radius_tc_to_open_escrow: isObject(form.is_radius_tc_to_open_escrow) ? form.is_radius_tc_to_open_escrow.value : form.is_radius_tc_to_open_escrow,
      schedule_sign_post_installation: isObject(form.schedule_sign_post_installation) ? form.schedule_sign_post_installation.value : form.schedule_sign_post_installation,
      rent_amount_term: isObject(form.rent_amount_term) ? form.rent_amount_term.value : form.rent_amount_term,
      confirmed_closed_on: form.confirmed_closed_on ? form.confirmed_closed_on : (form.closed_on ? form.closed_on : null),
      receivable_status: isObject(form.receivable_status) ? form.receivable_status.value : form.receivable_status,
      total_team_commission: totals.totalTeamCommission,
      total_brokerage_fees: totals.totalBrokerageFee,
      total_audit_fees: totals.totalAuditFee,
      total_pending_subscription_fees: totals.totalPendingSubscriptionFee,
      total_eno_fees: totals.totalEOFee,
      total_internal_referral_fees: totals.totalInternalReferralFee,
      total_radius_fees: totals.totalRadiusFee,
      total_misc_fees: totals.totalMiscellaneousFee,
      contribution_to_internal_cap_manual:
        form.contribution_to_internal_cap_manual === null
        || form.contribution_to_internal_cap_manual === undefined
        || form.contribution_to_internal_cap_manual === ""
          ? null
          : Number(form.contribution_to_internal_cap_manual),

      admin_name: user.twilio_client_name,
      vendor_id: selectedId,
      co_listing_agents: form.co_listing_agents ? form.co_listing_agents.map(agent => ({
        ...agent,
        // Ensure team_split_type is a string value
        team_split_type: agent.team_split_type ? (isObject(agent.team_split_type) ? agent.team_split_type.value : agent.team_split_type) : (form.team_split_type ? (isObject(form.team_split_type) ? form.team_split_type.value : form.team_split_type) : "percentage"),
        // Ensure receivable_status is a string value
        receivable_status: agent.receivable_status ? (isObject(agent.receivable_status) ? agent.receivable_status.value : agent.receivable_status) : (form.receivable_status ? (isObject(form.receivable_status) ? form.receivable_status.value : form.receivable_status) : null),
        agent_type: isObject(form.client_type) ? form.client_type.value : form.client_type, // ensure agent_type is passed
      })) : []
    }
    // console.log("payload is", payload) // Keep for debugging if needed, otherwise remove
    // before sending the final payload, can you add to payload the co_listing_agents array. This array would contain all the keys and values of the object from the form.agents_info array which has the is_primary key value pair as 0 and on top of that override the key value pair of this object with the first object of the form.co_listing_agents array.

    if (form.radius_transaction_type.value === null) {
      delete payload.radius_transaction_type
    } else {
      payload.radius_transaction_type = form.radius_transaction_type.value
    }
    if (!isEdit && form.file_type !== null && form.file_type.value === "new_listing") {
      payload.created_at = ""
      delete payload.row_created_at
      if (form.date_of_listing_submission === null) {
        payload.date_of_listing_submission = moment().format("YYYY-MM-DD HH:mm:ss")
      } else {
        payload.date_of_listing_submission = form.date_of_listing_submission
      }
    } 
    else if (isEdit && form.file_type !== null && form.file_type.value !== "new_listing") {
      if (form.row_created_at === null) {
        payload.row_created_at = moment().format("YYYY-MM-DD HH:mm:ss")
      } else {
        payload.row_created_at = form.row_created_at
      }
      if (form.created_at === 0 || form.created_at === null) {
        payload.created_at = moment(new Date()).unix()
      } else {
        payload.created_at = form.created_at
      }
    }
    else if (!isEdit && form.file_type !== null && form.file_type.value !== "new_listing") {
      delete payload.date_of_listing_submission
      if (form.row_created_at === null) {
        payload.row_created_at = moment().format("YYYY-MM-DD HH:mm:ss")
      } else {
        payload.row_created_at = form.row_created_at
      }
      if (form.created_at === 0 || form.created_at === null) {
        payload.created_at = moment(new Date()).unix()
      } else {
        payload.created_at = form.created_at
      }
    }

    if ((form.is_radius_tc_to_open_escrow && form.is_radius_tc_to_open_escrow.value === 1) && (fileType !== "new_listing"
    || fileType !== "listing_with_accepted_offer"
    || fileType !== "pending_lease"
    || fileType !== "lease_listing")) {
      if (isEmpty(allVendors)) {
        setIsCreatingDeal(false)
        toast.error(
          "Please fill Escrow Details", {
            position: "top-center",
            hideProgressBar: true,
          }
        )
        return
      }
      const mappedVendors = allVendors.map((vendors) => {
        if (vendors.id) {
          updateVendorDetails({
            vendors,
            agentId: payload.agent_id,
            vendorId: vendors.id,
          })
        }})
    }

    if (form.is_using_deal_tc !== null && form.is_using_deal_tc.value !== 0) {
      if (form.is_radius_tc_to_open_escrow !== null && form.is_radius_tc_to_open_escrow.value !== 0) {
        if (selectedId === null && isSelected === null) {
          setIsCreatingDeal(false)
          toast.error(
            "Please select a Vendor", {
              position: "top-center",
              hideProgressBar: true,
            }
          )
          return
        }
      }
    }

    if (isEdit && fileType === "new_listing" && form.client_type.value !== "seller") {
      setIsCreatingDeal(false)
      toast.error(
        "Please change the Client Type to Seller", {
          position: "top-center",
          hideProgressBar: true,
        }
      )
      return
    }
    if (dealId && selectedId) {
      selectVendorDetails({
        payload: {
          current_listing_step: "select_vendor",
          vendor_id: selectedId,
        },
        dealId,
        agentId: payload.agent_id,
      })
    }

    if (form.file_type && form.file_type.value === "pending_contract"
    || form.file_type && form.file_type.value === "pending_lease"
    || form.file_type && form.client_type && (form.file_type.value === "external_referral_agreement" && (form.client_type.value !== "landlord"))) {
      payload.list_price = ""
    }

    if (form.file_type && form.file_type.value === "listing_with_accepted_offer"
    || form.file_type && form.file_type.value === "pending_contract"
    || form.file_type && form.file_type.value === "dual") {
      payload.rent_amount = ""
    }

    if (form.file_type && form.file_type.value === "lease_listing"
    || form.file_type && form.file_type.value === "pending_lease"
    || form.file_type && form.client_type && (form.file_type.value === "external_referral_agreement" && (form.client_type.value === "landlord" || form.client_type.value === "tenant"))) {
      payload.price = ""
    }

    if (form.source?.label !== "Others") {
      payload.other_source = null
    }
    delete payload.audit_custom_unique_id
    createDeals({
      payload,
      history,
      isEdit: dealId,
      callbackVendors: (deal_id) => {
        setIsCreatingDeal(false)
        history.push("/broker/tc/list")
        allVendors.map((vendors) => {
          if (!(vendors.id)) {
            vendors.agent_id = payload.agent_id
            createVendorDetails({
              agentId: payload.agent_id,
              dealId: deal_id,
              vendors,
            })
          }
        })
      },
    })
  }

  selectAgent = (agent) => {
    const { getSecureIdForTC, getVendorDetails } = this.props
    getSecureIdForTC({
      agentId: agent.id,
    })
    getVendorDetails({
      agentId: agent.id,
      dealId: 0,
    })
    this.setState({
      selectedAgent: agent,
    })
  }

  // Modified method to handle multiple co-listing agents and update splits
  selectCoListingAgent = (agent) => {
    const { form } = this.state;
    
    // Create a default co-listing agent object with empty fee values
    const defaultCoListingAgent = {
      email: agent.email || agent.primary_email,
      phone: agent.phone,
      agent_id: agent.id,
      lastname: agent.lastname,
      firstname: agent.firstname,
      name: agent.firstname, // Added name field for compatibility
      // Initialize all fee and percentage fields with default values
      brokerage_fee: 0,
      audit_fee: 0,
      pending_subscription_fee: 0,
      eno_fee: 0,
      internal_referral_fee: 0,
      radius_fee: 0,
      misc_fees: 0,
      // Use form's team_split_type if available, otherwise default to "percentage"
      team_split_type: form.team_split_type ? (isObject(form.team_split_type) ? form.team_split_type.value : form.team_split_type) : "percentage",
      team_split_percentage: 0,
      commission_split: null, // No default split for newly added co-agents
      fixed_fee: 0,
      team_split_fixed_fee: 0,
      agent_reported_income: 0,
      co_agent_net_commission: 0,
      progress_to_radius_cap: 0,
      progress_to_internal_cap: 0,
      progress_to_internal_cap_new: 0,
      remaining_to_internal_cap_new: null,
      contribution_to_internal_cap_manual: null,
      // Use form's receivable_status if available
      receivable_status: form.receivable_status ? (isObject(form.receivable_status) ? form.receivable_status.value : form.receivable_status) : null,
      // Important - set is_primary to 0 to mark as co-agent
      is_primary: 0,
      total_agent_commission: null, // Initialize for new co-agent
      total_agent_team_commission: null, // Initialize for new co-agent team commission
    };

    // Create a new array with the new co-listing agent added to the existing ones
    const updatedCoListingAgents = [...(form.co_listing_agents || []), defaultCoListingAgent];

    this.setState({
      form: {
        ...form,
        co_listing_agents: updatedCoListingAgents,
        is_co_listed_deal: updatedCoListingAgents.length > 0 ? 1 : 0,
        // primary_agent_commission_split: 50 // Remove this line
      },
      hasChangedSplits: false // Reset flag to allow future updates based on agent count
    }, () => {
      // Update all agent splits based on the new state
      this.updateAgentSplits();
      
      // Calculate radius fee for the newly added co-agent
      this.calculateCoAgentRadiusFee(updatedCoListingAgents.length - 1);
    });
  }

  // Modified method to remove a co-listing agent and update splits
  removeCoListingAgent = (index) => {
    const { form } = this.state;
    
    // Create a new array without the agent at the specified index
    const updatedCoListingAgents = form.co_listing_agents.filter((_, i) => i !== index);
    
    this.setState({
      form: {
        ...form,
        co_listing_agents: updatedCoListingAgents,
        is_co_listed_deal: updatedCoListingAgents.length > 0 ? 1 : 0,
        // If we're removing the last co-agent, set primary agent to 100%
        primary_agent_commission_split: updatedCoListingAgents.length === 0 ? 100 : form.primary_agent_commission_split
      },
      // Reset showCoAgentSearch if we've removed all co-agents
      showCoAgentSearch: updatedCoListingAgents.length === 0 ? false : this.state.showCoAgentSearch,
      hasChangedSplits: false // Reset flag to allow future updates based on agent count
    }, () => {
      // Update all agent splits based on the new state
      this.updateAgentSplits();
    });
  }

  addClient = (data = {}) => {
    const { form } = this.state
    if (form.clients && typeof form.clients === "object") {
      form.clients.push({
        firstname: "",
        lastname: "",
        email: "",
        phone: "",
        client_id: null,
        // referral_id: null,
        is_primary: null,
        ...this.splitClientName(data),
        referral_id: null,
      })
      this.setState({
        ...form,
      })
      this.forceUpdate()
    }
    console.log("form data now is, ", form)
  }

  removeClient = (index) => {
    const { form } = this.state
    form.clients = form.clients.filter((x, i) => i !== index)
    this.setState({
      ...form,
    })
    this.forceUpdate()
  }

  handleFileUploader = (file, id) => {
    const {
      uploadTCFiles,
    } = this.props

    const {
      files,
    } = this.state
    const fileArr = files && files.length > 0 ? uniqBy([...files], "name") : []
    Object.values(file).forEach((item) => {
      fileArr.push(item)
    })

    this.setState({
      files: [...fileArr],
    })

    fileArr.forEach((fi) => {
      uploadTCFiles({
        file: fi,
        id,
      })
    })
  }

  updateRowCreatedAt = (form) => {
    if (form.row_created_at === null) {
      form.row_created_at = moment().format("YYYY-MM-DD HH:mm:ss")
    }
    return moment(form.row_created_at).format("YYYY-MM-DD")
  }

  updateDateOfListingSub = (form) => {
    if (form.date_of_listing_submission === null) {
      form.date_of_listing_submission = moment().format("YYYY-MM-DD HH:mm:ss")
    }
    return moment(form.date_of_listing_submission).format("YYYY-MM-DD")
  }

  // Helper function to truncate numbers to two decimal places
  truncateToTwoDecimals = (value) => {
    if (value === null || value === undefined || value === "") {
      return value;
    }
    const num = parseFloat(value);
    if (isNaN(num)) {
      return value;
    }
    return Math.round(num * 100) / 100;
  }

  // Helper function to format display value for primary_agent_misc_fees (truncated to 2 decimals)
  formatDisplayValue = (value) => {
    if (value === null || value === undefined || value === "" || value === 0) {
      return "$ 0";
    }
    const truncatedValue = this.truncateToTwoDecimals(value);
    return `$ ${truncatedValue}`;
  }

  // Helper function to format co-agent fee display values (truncated to 2 decimals)
  formatCoAgentFeeDisplay = (value) => {
    if (value === null || value === undefined || value === "" || value === 0) {
      return "$ 0";
    }
    const truncatedValue = this.truncateToTwoDecimals(value);
    return `$${truncatedValue}`;
  }
roundtTo2 = (data) => {

  if (data === null || data === undefined || data === "") {
    return "";
  }
  const cleanData = typeof data === 'string' ? data.replace(/^\$\s*/, '') : data;
  return `$ ${parseFloat(cleanData).toFixed(2)}`;

}
  handleDecimalPrice = (data) => {
    // Handle null, undefined, or empty string by returning empty string (shows placeholder)
    if (data === null || data === undefined || data === "") {
      return "";
    }
    // const num = parseFloat(data);
    // if (isNaN(num)) {
    //   return "";
    // }
    return `$ ${data}`;
    // Let USCurrencyFormat handle the number. It should manage rounding/padding to two decimal places.
    // return USCurrencyFormat(data, { isRound: false });
  }

  formatTitle = (data) => {
    if (data) {
      if (data.includes("_")) {
        const temp1 = data.replaceAll("_", " ")
        const temp2 = temp1.split(" ")
        for (let i = 0; i < temp2.length; i++) {
          temp2[i] = temp2[i].charAt(0).toUpperCase() + temp2[i].slice(1)
        }
        const final = temp2.join(" ")
        return final
      }
      return capitalizeFirstLetter(data)
    }
  }

  addRadiusFee = () => {
    const { form } = this.state
    const {
      brokerage_fee,
      agent_payout_fee,
      tc_fee,
      audit_fee,
      pending_subscription_fee,
      e_and_o_fee,
      referral_fee,
    } = form
    const total = `${Number(brokerage_fee) - Number(agent_payout_fee) + Number(tc_fee) + Number(audit_fee) + Number(pending_subscription_fee) + Number(e_and_o_fee) + Number(referral_fee)}`
    this.setState({
      form: {
        ...form,
        radius_transaction_fee: total,
      },
    })
  }

  // Add methods to handle the misc fee amounts
  
  // Update a specific fee amount at a given index
  handleLocalArrChange = (index, event) => {
    const { localArr } = this.state;
    const updatedArr = [...localArr];
    
    // Handle different input event types
    let value;
    if (event && event.target) {
      // Handle DOM event
      value = event.target.value;
    } else {
      // Handle direct value (from InputNumber)
      value = event;
    }
    
    // Convert to number, default to 0 if invalid
    const numValue = value === '' ? 0 : Number(value);
    // Only update if it's a valid number
    if (!isNaN(numValue)) {
      updatedArr[index] = numValue;
    }
    
    this.setState({
      localArr: updatedArr
    }, () => {
      // After updating the array, update the original pipe-separated string
      this.updateMiscFeeAmountsString();
    });
  }
  
  // Convert the array back to a pipe-separated string and update form
  updateMiscFeeAmountsString = () => {
    const { localArr } = this.state;
    
    // Filter out zero values before joining
    const nonZeroValues = localArr.filter(value => value !== 0);
    const pipeString = nonZeroValues.join(' | ');
    
    this.setState(prevState => ({
      form: {
        ...prevState.form,
        misc_fee_amounts: pipeString
      }
    }));
  }
  
  // Add a new fee amount to the array
  addFeeAmount = () => {
    this.setState(prevState => ({
      localArr: [...prevState.localArr, 0] // Add a new fee with default value 0
    }), () => {
      this.updateMiscFeeAmountsString();
    });
  }
  
  // Remove a fee amount function
  removeFeeAmount = (index) => {
    const { localArr } = this.state;
    const updatedArr = localArr.filter((_, i) => i !== index);
    
    this.setState({
      localArr: updatedArr
    }, () => {
      this.updateMiscFeeAmountsString();
    });
  }

  // Add this to your getTeams function or componentDidMount/componentDidUpdate
  initializeCoListingAgentsData = () => {
    const { form } = this.state;
    
    // Only do this if we have agents_info but no co_listing_agents data yet
    if (form?.agents_info?.length > 0 && 
       (!form.co_listing_agents || form.co_listing_agents.length === 0)) {
       
      // Find primary agent (with is_primary === 0)
      const primaryAgent = form.agents_info.find(agent => agent.is_primary === 0);
      
      if (primaryAgent) {
        // Create co_listing_agents array with this data
        this.setState({
          form: {
            ...form,
            co_listing_agents: [{ 
              ...primaryAgent,
              // Initialize any missing fields
              brokerage_fee: primaryAgent.brokerage_fee || 0,
              audit_fee: primaryAgent.audit_fee || 0,
              pending_subscription_fee: primaryAgent.pending_subscription_fee || 0,
              eno_fee: primaryAgent.eno_fee || 0,
              internal_referral_fee: primaryAgent.internal_referral_fee || 0,
              radius_fee: primaryAgent.radius_fee || 0,
              misc_fees: primaryAgent.misc_fees || 0,
              team_split_percentage: primaryAgent.team_split_percentage || 0,
              commission_split: primaryAgent.commission_split || 0,
              fixed_fee: primaryAgent.fixed_fee || 0,
              team_split_fixed_fee: primaryAgent.team_split_fixed_fee || 0,
              total_agent_commission: null, // Initialize for new co-agent
              total_agent_team_commission: null, // Initialize for new co-agent team commission
            }]
          }
        });
      }
    }
  };

  // Update this helper method to always return the most up-to-date value from co_listing_agents
  getCoAgentValue = (coAgent, fieldName, defaultValue = 0) => {
    // coAgent is directly from form.co_listing_agents in this context
    return coAgent && coAgent[fieldName] !== undefined ? coAgent[fieldName] : defaultValue;
  };

  // Add a new method to set default agent splits based on co-listing agent presence
  updateAgentSplits = () => {
    const { form } = this.state;
    const hasCoListingAgents = form.co_listing_agents && form.co_listing_agents.length > 0;
    
    // Only set defaults if they haven't been manually set before
    if (!this.state.hasChangedSplits) {
      if (hasCoListingAgents) {
        // With co-listing agents, set 50/50 split
        this.setState({
          form: {
            ...form,
            primary_agent_commission_split: 50,
            // co_listing_agents: form.co_listing_agents.map(agent => ({
            //   ...agent,
            //   commission_split: 50 // We should not override individual co-agent splits here
            // }))
          }
        });
      } else {
        // Without co-listing agents, primary agent gets 100%
        this.setState({
          form: {
            ...form,
            primary_agent_commission_split: 100
          }
        });
      }
    }
  }

  // Add a method to calculate radius fee for co-agents
  calculateCoAgentRadiusFee = (agentIndex) => {
    const { form } = this.state;
    
    if (!form.co_listing_agents || !form.co_listing_agents[agentIndex]) {
      return;
    }
    
    const coAgent = form.co_listing_agents[agentIndex];
    
    // Calculate the sum of all relevant fees for the co-agent
    const radiusTransactionFee = parseFloat(([
      coAgent.brokerage_fee || 0,
      // coAgent.agent_payout_fee || 0, // Uncomment if needed
      coAgent.audit_fee || 0,
      coAgent.pending_subscription_fee || 0,
      coAgent.eno_fee || 0,
      coAgent.internal_referral_fee || 0,
      // Any other fees that should be included
    ].reduce((acc, curr) => acc + (curr ? Number(curr) : Number(0)), 0)).toFixed(2));
    
    // Create a copy of the co_listing_agents array
    const updatedCoListingAgents = [...form.co_listing_agents];
    
    // Update the specific agent's radius_fee
    updatedCoListingAgents[agentIndex] = {
      ...updatedCoListingAgents[agentIndex],
      radius_fee: radiusTransactionFee
    };
    
    this.setState({
      form: {
        ...form,
        co_listing_agents: updatedCoListingAgents
      }
    });
  }

  // Add a method to calculate radius fees for all co-agents
  calculateAllCoAgentRadiusFees = () => {
    const { form } = this.state;
    
    if (!form.co_listing_agents || form.co_listing_agents.length === 0) {
      return;
    }
    
    // Create a new array with updated radius fees
    const updatedCoListingAgents = form.co_listing_agents.map(coAgent => {
      // Calculate the sum of all relevant fees for the co-agent
      const radiusTransactionFee = parseFloat(([
        coAgent.brokerage_fee || 0,
        // coAgent.agent_payout_fee || 0, // Uncomment if needed
        coAgent.audit_fee || 0,
        coAgent.pending_subscription_fee || 0,
        coAgent.eno_fee || 0,
        coAgent.internal_referral_fee || 0,
        // Any other fees that should be included
      ].reduce((acc, curr) => acc + (curr ? Number(curr) : Number(0)), 0)).toFixed(2));
      
      // Return the updated co-agent object
      return {
        ...coAgent,
        radius_fee: radiusTransactionFee
      };
    });
    
    this.setState({
      form: {
        ...form,
        co_listing_agents: updatedCoListingAgents
      }
    });
  }

  calculateTotals = () => {
    const { form } = this.state;

    // Initialize totals
    const totals = {
      totalTeamCommission: 0,
      totalBrokerageFee: 0,
      totalAuditFee: 0,
      totalPendingSubscriptionFee: 0,
      totalEOFee: 0,
      totalInternalReferralFee: 0,
      totalRadiusFee: 0,
      totalMiscellaneousFee: 0,
    };

    // Add primary agent values
    totals.totalTeamCommission += parseFloat(form.total_primary_agent_team_commission || 0);
    totals.totalBrokerageFee += parseFloat(form.brokerage_fee || 0);
    totals.totalAuditFee += parseFloat(form.audit_fee || 0);
    totals.totalPendingSubscriptionFee += parseFloat(form.pending_subscription_fee || 0);
    totals.totalEOFee += parseFloat(form.e_and_o_fee || 0);
    totals.totalInternalReferralFee += parseFloat(form.referral_fee || 0);
    totals.totalRadiusFee += parseFloat(form.radius_transaction_fee || 0);
    totals.totalMiscellaneousFee += parseFloat(form.primary_agent_misc_fees || 0);

    if (form.co_listing_agents && form.co_listing_agents.length > 0) {
      form.co_listing_agents.forEach((coAgent) => {
        totals.totalTeamCommission += parseFloat(coAgent.total_agent_team_commission || 0);
        totals.totalBrokerageFee += parseFloat(coAgent.brokerage_fee || 0);
        totals.totalAuditFee += parseFloat(coAgent.audit_fee || 0);
        totals.totalPendingSubscriptionFee += parseFloat(coAgent.pending_subscription_fee || 0);
        totals.totalEOFee += parseFloat(coAgent.eno_fee || 0);
        totals.totalInternalReferralFee += parseFloat(coAgent.internal_referral_fee || 0);
        totals.totalRadiusFee += parseFloat(coAgent.radius_fee || 0);
        totals.totalMiscellaneousFee += parseFloat(coAgent.misc_fees || 0);
      });
    }

    return totals;
  };

  render() {
    const {
      form,
      localArr,
      errorFields,
      selectedAgent,
      isAgentNotSelected,
      animatePricing,
      isEdit,
      isSelected,
      isLoading,
    } = this.state
    const {
      match,
      isShowAgentSearch,
      searchClientByText,
      secureIdForTC,
      preferences,
      dealsListingResponse,
      toggleEscrowDrawer,
      getVendorDetailsResponse,
      setEscrowEdit,
      isEditEscrow,
      setAllVendors,
      allVendors,
      selectedId,
      setSelectedId,
      isCreatingDeal,
      setIsCreatingDeal,
    } = this.props
    const dealID = get(match, "params.dealId")
    const agentId = get(match, "params.agentId")
    const isRadiusTC = get(preferences, "data.is_using_radius_transaction_coordination")
    const nowTime = (new Date().getTime() / 1000)
    const { data, isFetching } = dealsListingResponse
    const dealTCOptions = [
      { label: "Yes", value: 1 },
      { label: "No", value: 0 },
    ]
    const { data: vendorDetails } = getVendorDetailsResponse
    setAllVendors(vendorDetails && vendorDetails.vendors && vendorDetails.vendors)
    const teamSplitTypeOptions = [
      { label: "Percentage", value: "percentage" },
      { label: "Fixed Fee", value: "fixed_fee" },
      { label: "Both", value: "both" },
    ];
    const formattedTeamSplitType = teamSplitTypeOptions.find(
      option => option.value === form.team_split_type
    );

    const rbGrossNum = typeof form?.representing_broker_gross_commission === "number"
      ? form.representing_broker_gross_commission
      : parseFloat(String(form?.representing_broker_gross_commission || "").replace(/[^0-9.-]/g, "")) || 0
    const rbDedNum = typeof form?.representing_broker_commission_deductions === "number"
      ? form.representing_broker_commission_deductions
      : parseFloat(String(form?.representing_broker_commission_deductions || "").replace(/[^0-9.-]/g, "")) || 0
    const isRepresentingBrokerGrossAfterNegative = (rbGrossNum - rbDedNum) < 0

    const gcNum = typeof form?.gross_commission === "number"
      ? form.gross_commission
      : parseFloat(String(form?.gross_commission || "").replace(/[^0-9.-]/g, "")) || 0
    const cdNum = typeof form?.commission_deductions === "number"
      ? form.commission_deductions
      : parseFloat(String(form?.commission_deductions || "").replace(/[^0-9.-]/g, "")) || 0
    const grossCommissionAfterDeductionsDisplay = gcNum - cdNum
    const isGrossCommissionAfterDeductionsNegative = grossCommissionAfterDeductionsDisplay < 0

    const totals = this.calculateTotals();

    return (
     <>{isFetching ? (
       <div style={{ paddingTop: 200 }}>
         <Loader top="0px" bottom="0px" />
       </div>
     ) : (
       <Wrap>
         <Header>
           <div>
             <h1>
               {isEdit ? "Edit" : "Add"}
               {" "}
Deal 🤝
             </h1>
           </div>
           <div>
             <Button success onClick={this.createDeals} disabled={isCreatingDeal}>
               Save Deal
             </Button>
           </div>
         </Header>

         {isShowAgentSearch && (
           <Row style={{ margin: "20px 0px" }}>
             <Col>
               {selectedAgent ? (
                 <SelectedAgentView>
                   <div>
                     <p>
                       {selectedAgent.firstname}
                       {" "}
                       {selectedAgent.lastname}
                     </p>
                     <Label style={{ textTransform: "lowercase" }}>{selectedAgent.email}</Label>
                   </div>
                   <div>
                     <Button onClick={() => { this.setState({ selectedAgent: null }) }}>
                       Remove
                     </Button>
                   </div>
                 </SelectedAgentView>
               ) : (
                 <AgentSearch
                   onAgentSelect={this.selectAgent}
                   isAgentNotSelected={isAgentNotSelected}
                 />
               )}
             </Col>
           </Row>
         )}
         <SectionWrap>
           <h6>
             Basic Info
           </h6>
           <React.Fragment>
             <Label>
               Property Details
             </Label>
             <Row noMargin>
               <Col>
                 <TextInput
                   name="listing_address"
                   placeholder="Address"
                   value={form.listing_address}
                   onChange={this.handleChange}
                   isError={errorFields.listing_address}
                   isHideLabel
                 />
               </Col>
             </Row>
             <Row style={{ marginTop: 0 }}>
               <Col>
                 <Label></Label>
                 <GoogleLocation
                   type="cities"
                   value={form.city}
                   restrict={US_OBJ}
                   placeholder={form.city || "City"}
                   location={(data) => {
                     const city = get(data, "locality.long_name") || get(data, "address")
                     const state = get(data, "administrative_area_level_1.long_name")
                     this.setState({
                       form: {
                         ...form,
                         city,
                         state,
                       },
                     })
                   }}
                 />
               </Col>
               <Col>
                 <Select
                   name="state"
                   placeholder="State"
                   value={form.state ? { value: form.state, label: form.state.charAt(0).toUpperCase() + form.state.slice(1) } : null}
                   onChange={(selectedOption) => {
                     this.handleChange({
                       target: {
                         name: "state",
                         value: selectedOption ? selectedOption.value : ""
                       }
                     })
                   }}
                   options={[
                     {
                       value: "California",
                       label: "California",
                     },
                     {
                       value: "Washington",
                       label: "Washington",
                     },
                     {
                       value: "Georgia",
                       label: "Georgia",
                     },
                     {
                       value: "Texas",
                       label: "Texas",
                     },
                     {
                       value: "Florida",
                       label: "Florida",
                     },
                     {
                       value: "Colorado",
                       label: "Colorado",
                     },
                     {
                       value: "Oregon",
                       label: "Oregon",
                     },
                     {
                       value: "Arizona",
                       label: "Arizona",
                     },
                   ]}
                   styles={{
                     control: (provided, state) => ({
                       ...provided,
                       marginTop: '27px',
                       borderColor: errorFields.state ? '#ff4d4f' : provided.borderColor,
                       '&:hover': {
                         borderColor: errorFields.state ? '#ff4d4f' : provided.borderColor,
                       }
                     }),
                     menu: (provided) => ({
                       ...provided,
                       zIndex: 9999
                     })
                   }}
                 />
               </Col>
               <Col>
                 <TextInput
                   name="zipcode"
                   placeholder="Zip Code"
                   value={form.zipcode}
                   onChange={this.handleChange}
                   isError={errorFields.zipcode}
                 />
               </Col>
             </Row>
             <Row style={{ margin: "20px 0px" }}>
               <Col>
                 <Label>CO Agents</Label>
                 {form.co_listing_agents && form.co_listing_agents.length > 0 && (
                  <List
                    style={{ marginBottom: "10px" }}
                    bordered
                    dataSource={form.co_listing_agents}
                    renderItem={(agent, index) => (
                      <List.Item
                        actions={[
                          <AntdButton type="link" danger onClick={() => this.removeCoListingAgent(index)}>
                            Remove
                          </AntdButton>
                        ]}
                      >
                        <List.Item.Meta
                          title={`${agent.firstname || ""} ${agent.lastname || ""}`}
                          description={agent.email || (agent.primary_email || "No email provided")}
                        />
                      </List.Item>
                    )}
                  />
                 )}
                 <AgentSearch
                   onAgentSelect={this.selectCoListingAgent}
                   // Add a key to potentially reset AgentSearch if needed after selection, e.g., if it holds internal state
                   // key={`agent-search-${form.co_listing_agents ? form.co_listing_agents.length : 0}`}
                 />
               </Col>
             </Row>
             <Row>
               <Col>
                 <Label>Client Details</Label>
                 <ClientSearch
                   searchClientByText={searchClientByText}
                   secureIdForTC={secureIdForTC}
                   agentId={(selectedAgent && selectedAgent.id) || agentId}
                   addClient={this.addClient}
                   clients={form.clients}
                   handleInput={(newClient) => {
                     this.setState({
                       ...form,
                       clients: newClient,
                     })
                   }}
                 />
               </Col>
             </Row>
             <Row style={{ marginTop: 10 }}>
               <Col>
                 <ClientSelector
                   clients={form.clients}
                   agentId={(selectedAgent && selectedAgent.id) || agentId}
                   secureIdForTC={secureIdForTC}
                   handleInput={(newClient) => {
                     this.setState({
                       ...form,
                       clients: newClient,
                     })
                   }}
                   errorFields={errorFields}
                   addClient={this.addClient}
                   searchClientByText={searchClientByText}
                   removeClient={this.removeClient}
                   isEdit={isEdit}
                   dealClientType={isObject(form.client_type) ? form.client_type.value : form.client_type}
                   isDual={(isObject(form.file_type) ? form.file_type.value : form.file_type) === "dual"}
                 />
               </Col>
             </Row>
             <Row>
               <Col>
                 <Label>Representing</Label>
                 <Select
                   name="client_type"
                   options={[
                     { label: "Buyer", value: "buyer" },
                     { label: "Seller", value: "seller" },
                     { label: "Landlord", value: "landlord" },
                     { label: "Tenant", value: "tenant" },
                     { label: "Referral", value: "referral" },
                   ]}
                   value={form.client_type}
                   onChange={(selectedItem) => {
                     this.setState({
                       form: {
                         ...form,
                         client_type: selectedItem,
                       },
                     })
                   }}
                 />
               </Col>
               <Col>
                 {/* <Label skyslope>SkySlope ID</Label> */}
                 <TextInput
                   label="Skyslope Unique ID"
                   name="skyslope_unique_id"
                   placeholder="Enter ID"
                   value={form.skyslope_unique_id}
                   onChange={this.handleChange}
                   isError={errorFields.skyslope_unique_id}
                 />
               </Col>
               <Col></Col>
             </Row>
             {/* File Upload */}
             <Row>
               {isEdit && form.file_creation_flow !== "offer" ? (
                 <Col>
                   <Label>File Type</Label>
                   <Select
                     name="file_type"
                     options={FILE_TYPES_LISTING}
                     value={form.file_type}
                     onChange={(selectedItem) => {
                       this.setState({
                         form: {
                           ...form,
                           file_type: selectedItem,
                         },
                       })
                     }}
                   />
                   {form.file_type.value === "new_listing" && isEdit ? (
                     <Label error>* Please fill the additional listing related details in the "TC Listing Details" tab once converted to listings</Label>
                   ) : null }
                 </Col>
               ) : (
                 <Col>
                   <Label>File Type</Label>
                   <Select
                     name="file_type"
                     options={FILE_TYPES}
                     value={form.file_type}
                     onChange={(selectedItem) => {
                       this.setState({
                         form: {
                           ...form,
                           file_type: selectedItem,
                         },
                       })
                     }}
                   />
                 </Col>
               )}
             </Row>
           </React.Fragment>
         </SectionWrap>

         <SectionWrap isAnimate={animatePricing} id="tc-pricing-section">
           <h6>
             Transaction Details
           </h6>
           <Row noMargin>
             <Col>
               <Label>
                Radius Transaction Type
               </Label>
               <Select
                 name="radius_transaction_type"
                 placeholder="Radius Transaction Type"
                 options={RADIUS_TRANSACTION_TYPE}
                //  value={form.radius_transaction_type}
                value={form.radius_transaction_type ? 
                  { 
                    label: this.getTransactionTypeLabel(form.radius_transaction_type), 
                    value: form.radius_transaction_type 
                  } : 
                  null
                }
                 onChange={(selectedItem) => {
                   this.setState({
                     form: {
                       ...form,
                       radius_transaction_type: selectedItem,
                     },
                   })
                 }}
               />
             </Col>
           </Row>
           <Row>
             {(form.file_type
              && (
                form.file_type.value === "pending_contract"
                || form.file_type && form.file_type.value === "listing_with_accepted_offer"
                || form.file_type.value === "dual"
                || form.client_type && (form.file_type.value === "external_referral_agreement" && (form.client_type.value !== "landlord" && form.client_type.value !== "tenant"))
              )) && (
               <Col>
                 <TextInput
                   name="price"
                   label="Purchase Price"
                   placeholder="$1,000,000"
                   value={this.handleDecimalPrice(form.price)}
                   onChange={(e) => {
                     this.handleChange(e, deformatCurrency)
                   }}
                   isError={errorFields.price}
                 />
               </Col>
             )}
             <Col>
               {(
                 form.file_type && form.file_type.value === "listing_with_accepted_offer"
                 || form.file_type && form.file_type.value === "dual"
                 || form.file_type && form.file_type.value === "lease_listing"
                 || form.file_type && form.client_type && (form.file_type.value === "external_referral_agreement" && (form.client_type.value === "landlord"))
               ) && (
                 <TextInput
                   name="list_price"
                   label="List Price"
                   placeholder="$900,000"
                   value={this.handleDecimalPrice(form.list_price)}
                   onChange={(e) => {
                     this.handleChange(e, deformatCurrency)
                   }}
                   isError={errorFields.list_price}
                 />
               )}
               {form.file_type && (
                 form.file_type.value === "pending_lease"
                || form.file_type.value === "lease_listing"
                || form.client_type && (form.file_type.value === "external_referral_agreement" && (form.client_type.value === "tenant" || form.client_type.value === "landlord"))
               ) && (
                 <TextInput
                   name="rent_amount"
                   label="Rent Amout"
                   placeholder="$1234"
                   value={this.handleDecimalPrice(form.rent_amount)}
                   onChange={(e) => {
                     this.handleChange(e, deformatCurrency)
                   }}
                   isError={errorFields.rent_amount}
                 />
               )}
             </Col>
             {form.file_type && (
               form.file_type.value === "pending_lease"
               || form.file_type.value === "lease_listing"
               || form.client_type && (form.file_type.value === "external_referral_agreement" && (form.client_type.value === "tenant" || form.client_type.value === "landlord"))
             ) && (
               <Col>
                 <Label>
                  Rent Amount Term
                 </Label>
                 <Select
                   name="rent_amount_term"
                   placeholder="Rent Amount Term"
                   options={[
                     { label: "Monthly", value: "monthly" },
                     { label: "Annually", value: "annually" },
                     { label: "other", value: "other" },
                   ]}
                   value={form.rent_amount_term}
                   onChange={(selectedItem) => {
                     this.setState({
                       form: {
                         ...form,
                         rent_amount_term: selectedItem,
                         other_rent_amount_term: "",
                       },
                     })
                   }}
                 />
               </Col>
             )}
             {form.rent_amount_term
              && (
                form.rent_amount_term.value === "other"
              ) && (
               <Col>
                 <TextInput
                   name="other_rent_amount_term"
                   label="Other Rent Amount Term"
                   placeholder="Enter other term"
                   value={form.other_rent_amount_term}
                   onChange={this.handleChange}
                   isError={errorFields.rent_amount}
                 />
               </Col>
             )}

           </Row>

           {form.client_type && form.client_type.value === "referral" && (
           <div style={{ borderTop: "1px solid #e0e0e0",borderBottom: "1px solid #e0e0e0" ,marginTop: 20, paddingTop: 20, paddingBottom: 20 }}>
             <h6 style={{ margin: "0 0 12px", fontSize: 14, fontWeight: 700, color: "#999" }}>
               Representing broker commission
             </h6>
             <Row>
               <Col>
                 <Label style={{ width: "159px" }}>Commission type</Label>
                 <Select
                   name="representing_broker_commission_type"
                   value={form.representing_broker_commission_type}
                   options={COMMISSION_TYPE}
                   onChange={(selectedItem) => {
                     this.setState({
                       form: {
                         ...form,
                         representing_broker_commission_type: selectedItem,
                       },
                     }, () => this.calculateRepresentingBrokerGrossCommission())
                   }}
                 />
               </Col>
               {(
                 (form.representing_broker_commission_type && form.representing_broker_commission_type.value === "percentage")
                  || (form.representing_broker_commission_type && form.representing_broker_commission_type.value === "both")
               ) && (
                 <Col>
                   <TextInput
                     name="representing_broker_commission_percentage"
                     label="Commission percentage"
                     typeSymbol="%"
                     placeholder="4%"
                     value={form.representing_broker_commission_percentage}
                     onChange={this.handleChange}
                     isError={errorFields.representing_broker_commission_percentage}
                   />
                 </Col>
               )}
               {(form.representing_broker_commission_type
                && (form.representing_broker_commission_type.value === "fixed_fee" || form.representing_broker_commission_type.value === "both"))
                && (
                  <Col>
                    <TextInput
                      name="representing_broker_commission_fixed_fee"
                      label="Fixed fee"
                      placeholder="$2,000"
                      isError={errorFields.representing_broker_commission_fixed_fee}
                      value={this.handleDecimalPrice(form.representing_broker_commission_fixed_fee)}
                      onChange={(e) => {
                        this.handleChange(e, deformatCurrency)
                        setTimeout(() => this.calculateRepresentingBrokerGrossCommission(), 0);
                      }}
                    />
                  </Col>
                )}
               <Col>
                 <TextInput
                   name="representing_broker_gross_commission"
                   label="Gross commission (representing broker)"
                   placeholder="$2,000"
                   isError={errorFields.representing_broker_gross_commission}
                   value={this.handleDecimalPrice(form.representing_broker_gross_commission)}
                   onChange={(e) => {
                     this.handleChange(e, deformatCurrency)
                   }}
                 />
               </Col>
             </Row>
             <Row>
               <Col>
                 <TextInput
                   name="representing_broker_commission_deductions"
                   label="Commission deductions (representing broker)"
                   placeholder="$2,000"
                   isError={errorFields.representing_broker_commission_deductions}
                   value={this.handleDecimalPrice(form.representing_broker_commission_deductions)}
                   onChange={(e) => {
                     this.handleChange(e, deformatCurrency)
                   }}
                 />
               </Col>
               <Col>
                 <TextInput
                   name="representing_broker_gross_commission_after_deductions"
                   label="Gross commission after deductions (representing broker)"
                   placeholder="$2,000"
                   isError={errorFields.representing_broker_gross_commission_after_deductions || isRepresentingBrokerGrossAfterNegative}
                   value={this.roundtTo2(this.handleDecimalPrice(rbGrossNum - rbDedNum))}
                 />
               </Col>
             </Row>
           </div>
           )}

           <Row>
             <Col>
               <Label
                 style={{
                   width: "159px",
                 }}
               >
                Commission Type
               </Label>
               <Select
                 name="commission_type"
                 value={form.commission_type}
                 options={COMMISSION_TYPE}
                 onChange={(selectedItem) => {
                   this.setState({
                     form: {
                       ...form,
                       commission_type: selectedItem,
                     },
                   }, () => {
                     // Recalculate gross commission when commission type changes
                     this.calculateGrossCommission();
                   })
                 }}
               />
             </Col>
             {(
               (form.commission_type && form.commission_type.value === "percentage")
                || (form.commission_type && form.commission_type.value === "both")
             ) && (
               <Col>
                 <TextInput
                   name="commision_percentage"
                   label="Commission Percentage"
                   typeSymbol="%"
                   placeholder="4%"
                   value={form.commision_percentage}
                   onChange={this.handleChange}
                   isError={errorFields.commision_percentage}
                 />
               </Col>
             )}

             {(form.commission_type
              && (form.commission_type.value === "fixed_fee" || form.commission_type.value === "both"))
              && (
                <Col>
                  <TextInput
                    name="fixed_fee"
                    label="Fixed Fee"
                    placeholder="$2,000"
                    isError={errorFields.fixed_fee}
                    value={this.handleDecimalPrice(form.fixed_fee)}
                    onChange={(e) => {
                      this.handleChange(e, deformatCurrency)
                      // After updating fixed fee, recalculate gross commission
                      setTimeout(() => this.calculateGrossCommission(), 0);
                    }}
                  />
                </Col>
              )}
             {/* {(
               (form.commission_type && form.commission_type.value === "percentage")
                 || (form.commission_type && form.commission_type.value === "both")
                 || true
             ) && (
               <Col>
                 <TextInput
                   name="team_split_percentage"
                   label="Split with Team %"
                   typeSymbol="%"
                   placeholder="4%"
                   value={form.team_split_percentage}
                   onChange={this.handleChange}
                   isError={errorFields.team_split_percentage}
                 />
               </Col>
             )} */}
             {(form.file_type
                && form.file_type.value === "lease_listing"
                && form.file_type.value === "pending_lease"
                || true
             ) && (
               <Col>
                 <TextInput
                   name="gross_commission"
                   label="Gross Commission"
                   placeholder="$2,000"
                   isError={errorFields.gross_commission}
                   value={this.handleDecimalPrice(form.gross_commission)}
                   onChange={(e) => {
                     this.handleChange(e, deformatCurrency)
                   }}
                 />
               </Col>
             )}
           </Row>
           <Row>
              <Col>
                <TextInput
                  name="commission_deductions"
                  label="Commission deductions"
                  placeholder="$2,000"
                  isError={errorFields.commission_deductions}
                  value={this.handleDecimalPrice(form.commission_deductions)}
                  onChange={(e) => {
                    this.handleChange(e, deformatCurrency)
                  }}
                />
              </Col>
                <Col>
                  <TextInput
                    name="gross_commission_after_deductions"
                    label="Gross commission after deductions"
                    placeholder="$2,000"
                    isError={errorFields.gross_commission_after_deductions || isGrossCommissionAfterDeductionsNegative}
                    value={this.roundtTo2(this.handleDecimalPrice(grossCommissionAfterDeductionsDisplay))}
                  />
                </Col>
             {/* <Col>
               <TextInput
                 name="agent_commission"
                 label="Agent Commission"
                 placeholder="$2,000"
                 isError={errorFields.agent_commission}
                 value={this.handleDecimalPrice(form.agent_commission)}
                 onChange={(e) => {
                   this.handleChange(e, deformatCurrency)
                 }}
               />
             </Col> */}
           </Row>
          
           {/* <Row>
             <Col>
               <Label>
                  Referral Feeeee
               </Label>
               <InputNumber
                 name="new_referral_fee"
                 label="New Referral Fee"
                 placeholder="$2,000"
                 isError={errorFields.new_referral_fee}
                 value={form.new_referral_fee}
               />
             </Col>
             <Col>
             <InputNumber
                 name="brokerage_net_commission"
                 label="Brokerage Net Commission"
                 placeholder="$2,000"
                 isError={errorFields.brokerage_net_commission}
               />
             </Col>
           </Row> */}
           <Row>
             {(
               (form.file_type && form.file_type.value === "external_referral_agreement")
                && (form.commission_type && form.commission_type.value !== "fixed_fee")
             ) && (
               <Col>
                 <TextInput
                   name="closing_agent_commision_percentage"
                   label="Closing Agent Comm. %"
                   typeSymbol="%"
                   placeholder="2.5%"
                   value={form.closing_agent_commision_percentage}
                   onChange={this.handleChange}
                   isError={errorFields.closing_agent_commision_percentage}
                 />
               </Col>
             )}
             <Col>
               <Label>TRANSACTION TYPE</Label>
               <Select
                 name="transaction_type"
                 options={TRANSACTION_TYPE}
                 value={form.transaction_type}
                 onChange={(selectedItem) => {
                   this.setState({
                     form: {
                       ...form,
                       transaction_type: selectedItem,
                     },
                   })
                 }}
               />
             </Col>
             <Col>
               {(form.transaction_type && form.transaction_type.value === "other") && (
                 <TextInput
                   fullWidth
                   fullHeight
                   name="other_transaction_type"
                   label="OTHER TRANSACTION TYPE"
                   placeholder="Other Transaction Type"
                   value={form.other_transaction_type}
                   onChange={this.handleChange}
                   isError={errorFields.other_transaction_type}
                 />
               )}
             </Col>
           </Row>
           <Row style={{ marginTop: 20 }}>
             <Col>
               <Label>
                 Receivable Status
               </Label>
               <Select
                 name="receivable_status"
                 placeholder="Select receivable status"
                 // Format the value to display correctly in the dropdown
                 value={form.receivable_status ? 
                   { 
                     label: this.getLabel(form.receivable_status), 
                     value: form.receivable_status 
                   } : 
                   null
                 }
                 options={[
                   { label: "Commission Expected", value: "commission_expected" },
                   { label: "Commission Received", value: "commission_received" },
                   { label: "Agent/Partner Payment Initiated", value: "payment_initiated" },
                   { label: "Payment Finalized", value: "payment_finalized" }
                 ]}
                 onChange={(selectedItem) => {
                   this.setState({
                     form: {
                       ...form,
                       receivable_status: selectedItem.value // Store just the value string, not the entire object
                     }
                   });
                 }}
               />
               {/* Add disclaimer for Payment Initiated status */}
               {form.receivable_status && form.receivable_status === "payment_initiated" && (
                 <div style={{ 
                   marginTop: "8px", 
                   fontSize: "12px", 
                   color: "#666", 
                   fontStyle: "italic",
                   padding: "8px",
                   background: "#f9f9f9",
                   borderRadius: "4px"
                 }}>
                   Note: Once payment is initiated, it can take 24-48 hours to process.
                 </div>
               )}
             </Col>
           </Row>
           <Row>
             {form.file_type && form.file_type.value !== "new_listing" && (
               <Col>
                 <TextInput
                   name="created_at"
                   label="Acceptance Date (Date of Contract)"
                   fullWidth
                   fullHeight
                   placeholder="Contract On"
                   type="date"
                   max={moment().format("YYYY-MM-DD")}
                   value={form.created_at ? moment.unix(form.created_at).format("YYYY-MM-DD") : moment(new Date()).format("YYYY-MM-DD")}
                   onChange={(e) => {
                     this.setState({
                       form: {
                         ...form,
                         created_at: moment(e.target.value).unix(),
                       },
                     })
                   }}
                 />
               </Col>
             )}
             <Col>
               <TextInput
                 name="closed_on"
                 min={moment(nowTime).format("YYYY-MM-DD")}
                 label="Est. Closing Date (Escrow)"
                 placeholder="Close On"
                 fullWidth
                 fullHeight
                 type="date"
                 value={form.closed_on ? moment.unix(form.closed_on).format("YYYY-MM-DD") : null}
                 isError={errorFields.closed_on}
                 onChange={(e) => {
                   this.setState({
                     form: {
                       ...form,
                       closed_on: e.target.value ? moment(e.target.value).unix() : null,
                       confirmed_closed_on: e.target.value ? moment(e.target.value).unix() : null,
                     },
                   })
                 }}
               />
             </Col>
             <Col>
               <TextInput
                 name="confirmed_closed_on"
                 min={moment(nowTime).format("YYYY-MM-DD")}
                 label="Confirmed/Tentative Closed Date (Escrow)"
                 placeholder="Confirmed Closed On"
                 type="date"
                 fullWidth
                 fullHeight
                 value={form.confirmed_closed_on !== null ? moment.unix(form.confirmed_closed_on).format("YYYY-MM-DD") : (form.closed_on ? moment.unix(form.closed_on).format("YYYY-MM-DD") : null)}
                 isError={errorFields.confirmed_closed_on}
                 onChange={(e) => {
                   this.setState({
                     form: {
                       ...form,
                       confirmed_closed_on: e.target.value ? moment(e.target.value).unix() : null,
                     },
                   })
                 }}
               />
             </Col>
             {(form.file_type && form.file_type.value === "lease_listing"
                 || form.file_type && form.file_type.value === "pending_lease"
             ) && (
               <Col>
                 <TextInput
                   name="lease_commencement_on"
                   label="Lease Commencement Date"
                   placeholder="Lease Commencement Date"
                   fullHeight
                   type="date"
                   value={moment.unix(form.lease_commencement_on || nowTime).format("YYYY-MM-DD")}
                   isError={errorFields.lease_commencement_on}
                   onChange={(e) => {
                     this.setState({
                       form: {
                         ...form,
                         lease_commencement_on: moment(e.target.value).unix(),
                       },
                     })
                   }}
                 />
               </Col>
             )}
           </Row>

           <Row>
             {form.file_type && form.file_type.value !== "new_listing" && (
               <Col>
                 <TextInput
                   name="row_created_at"
                   label="Date of Contract Submission"
                   placeholder="Submission Date"
                   fullHeight
                   type="date"
                   value={this.updateRowCreatedAt(form)}
                   isError={errorFields.row_created_at}
                   onChange={(e) => {
                     this.setState({
                       form: {
                         ...form,
                         row_created_at: moment(e.target.value).format("YYYY-MM-DD 00:00:00"),
                       },
                     })
                   }}
                 />
               </Col>
             )}
           </Row>
         </SectionWrap>
         <SectionWrap isAnimate={animatePricing} id="tc-pricing-section">
          
           <h6>
              {
                isEdit ? (
                  <>
                    Commission Details (Primary Agent: {form?.agent_firstname} {form?.agent_lastname})
                  </>
                ) : (
                  "Commission Details: Primary Agent"
                )
              }
           </h6>
           <Row>
             {/* <Col>
               <Label
                 style={{
                   width: "159px",
                 }}
               >
                Primary Agent Split Type
               </Label>
               <Select
                 name="primary_agent_commission_type"
                 value={form.primary_agent_commission_type}
                 options={COMMISSION_TYPE}
                 onChange={(selectedItem) => {
                   this.setState({
                     form: {
                       ...form,
                       primary_agent_commission_type: selectedItem,
                     },
                   }, () => {
                     console.log("form.primary_agent_commission_type is ", this.state.form.primary_agent_commission_type)
                   })
                 }}
               />
             </Col> */}
             {/* {(
               (form.primary_agent_commission_type && form.primary_agent_commission_type.value === "percentage")
                || (form.primary_agent_commission_type && form.primary_agent_commission_type.value === "both")
             ) && ( */}
               <Col>
                 <TextInput
                   name="primary_agent_commission_split"
                   label="Primary Agent Split"
                   typeSymbol="%"
                   placeholder="4%"
                   // value={form.commision_percentage}
                   value={form.primary_agent_commission_split}
                   onChange={(e) => {
                     this.handlePrimaryAgentSplitChange(e);
                   }}
                   isError={errorFields.primary_agent_commission_split}
                 />
               </Col>

               <Col>
                  <TextInput
                   name="total_primary_agent_commission"
                   label="Total Primary Agent Commission"
                  //  typeSymbol="$"
                   placeholder="$0"
                   disabled
                   // value={form.commision_percentage}
                  //  value={form.total_primary_agent_commission}
                  value={
                    form.total_primary_agent_commission !== undefined &&
                    form.total_primary_agent_commission !== '' &&
                    !isNaN(parseFloat(form.total_primary_agent_commission))
                      ? `$ ${parseFloat(form.total_primary_agent_commission).toFixed(2)}`
                      : ''
                  }
                  onChange={(e) => {
                    const raw = e.target.value.replace(/[^0-9.]/g, ''); // remove $ and non-numeric
                    this.handleTotalPrimaryAgentCommissionChange({ target: { value: raw } });
                  }}
                   isError={errorFields.total_primary_agent_commission}
                  />

               </Col>
             {/* )} */}

             {/* {(form.primary_agent_commission_type
              && (form.primary_agent_commission_type.value === "fixed_fee" || form.primary_agent_commission_type.value === "both"))
              && (
                <Col>
                  <TextInput
                    name="primary_agent_fixed_fee"
                    label="Primary Agent Fixed Fee"
                    placeholder="$10,000"
                    isError={errorFields.primary_agent_fixed_fee}
                    value={this.handleDecimalPrice(form.primary_agent_fixed_fee)}
                    onChange={(e) => {
                      this.handleChange(e, deformatCurrency)
                    }}
                  />
                </Col>
              )} */}

              {/* add the code from here for primary agent team split or percentage, think of how these values would be shown on basis of team_split_type as that might come null and don't think we can rely on commission_type for this. */}
             {/* {(
               (form.commission_type && form.commission_type.value === "percentage")
                 || (form.commission_type && form.commission_type.value === "both")
                 || true
             ) && (
               <Col>
                 <TextInput
                   name="team_split_percentage"
                   label="Split with Team %"
                   typeSymbol="%"
                   placeholder="4%"
                   value={form.team_split_percentage}
                   onChange={this.handleChange}
                   isError={errorFields.team_split_percentage}
                 />
               </Col>
             )} */}
           </Row>
           <Row>
              <Col>
               <Label
                 style={{
                   width: "159px",
                 }}
               >
                Team Split Type
               </Label>
               <Select
                 name="team_split_type"
                  value={teamSplitTypeOptions.find(option => option.value === form.team_split_type) || null} // Map the value to the correct format
                    options={teamSplitTypeOptions}
                    onChange={(selectedItem) => {
                      this.setState({
                        form: {
                          ...form,
                          team_split_type: selectedItem.value,
                     },
                    })
                 }}
               />
              </Col>
              {(
                (form.team_split_type && form.team_split_type === "fixed_fee")
                  || (form.team_split_type && form.team_split_type=== "both")
              ) && (
                <>
                <Col>
                  <TextInput
                    name="team_split_fixed_fee"
                    label="Team Fee"
                    placeholder="$0"
                    // value={form.commision_percentage}
                    // value={form.primary_agent_commission_split}
                    value = {form.team_split_fixed_fee === 0 ? this.handleDecimalPrice("0") : this.handleDecimalPrice(form.team_split_fixed_fee)}
                    onChange={(e) => {
                      this.handleChange(e, deformatCurrency);
                      this.setState({}, () => {
                        this.handlePrimaryTeamFeeChange();
                      });
                    }}
                    isError={errorFields.team_split_fixed_fee}
                  />
                </Col>
                {
                    
                    form?.team_split_type === "fixed_fee" && <Col>
                      <TextInput
                        name="total_primary_agent_team_commission"
                        label="Primary Agent Team Commission"
                        placeholder="$0"
                        value={this.roundtTo2(this.handleDecimalPrice(form.total_primary_agent_team_commission))}
                        onChange={this.handleTotalPrimaryAgentTeamCommissionChange} // Use new handler
                        isError={errorFields.total_primary_agent_team_commission}
                      />
                    </Col>
                  
                }
                </>
                
              )}

              {(
                (form.team_split_type && form.team_split_type === "percentage")
                  || (form.team_split_type && form.team_split_type === "both")
              ) && (
                <>
                  <Col>
                    <TextInput
                      name="team_split_percentage"
                      label="Team Split" // Changed label for consistency
                      typeSymbol="%"
                      placeholder="0"
                      value={(form.team_split_percentage !== undefined && form.team_split_percentage !== null ? form.team_split_percentage : "").toString()}
                      onChange={this.handlePrimaryTeamSplitPercentageChange} // Use new handler
                      isError={errorFields.team_split_percentage}
                    />
                  </Col>
                  {
                    
                      <Col>
                        <TextInput
                          name="total_primary_agent_team_commission"
                          label="Primary Agent Team Commission"
                          placeholder="$0"
                          value={this.roundtTo2(this.handleDecimalPrice(form.total_primary_agent_team_commission))}
                          onChange={this.handleTotalPrimaryAgentTeamCommissionChange} // Use new handler
                          isError={errorFields.total_primary_agent_team_commission}
                        />
                      </Col>
                    
                  }
                </>
              )}

           </Row>
           <Row>
             <Col>
               <Label>Contribution to Cap</Label>
               <InputNumber
                 name="contribution_to_internal_cap_manual"
                 placeholder="$0"
                 value={
                   form.contribution_to_internal_cap_manual === null
                   || form.contribution_to_internal_cap_manual === undefined
                     ? undefined
                     : Number(form.contribution_to_internal_cap_manual)
                 }
                 formatter={(v) => (v === undefined || v === null ? "" : `$${v}`)}
                 parser={(v) => (v === undefined || v === null || v === "$" ? null : v.replace(/\$\s?|(,*)/g, ""))}
                 onChange={this.handleContributionToCapManualChange}
               />
             </Col>
           </Row>
           {/* <Row noMargin>
             <Col>
               <Label
                 style={{
                   width: "159px",
                 }}
               >
                Agentsss Commission Type
               </Label>
               <Select
                 name="primary_agent_commission_type"
                 value={form.primary_agent_commission_type}
                 options={COMMISSION_TYPE}
                 onChange={(selectedItem) => {
                   this.setState({
                     form: {
                       ...form,
                       primary_agent_commission_type: selectedItem,
                     },
                   })
                 }}
               />
             </Col>
             {(
               (form?.primary_agent_commission_type && form?.primary_agent_commission_type?.value === "percentage")
                || (form.primary_agent_commission_type && form.primary_agent_commission_type.value === "both")
             ) && (
               <Col>
                 <TextInput
                   name="primary_agent_commission_split"
                   label="Agent Commission Percentage"
                   typeSymbol="%"
                   placeholder="4%"
                   value={form.primary_agent_commission_split}
                   onChange={this.handleChange}
                   isError={errorFields.primary_agent_commission_split}
                 />
               </Col>
             )}

             {(form.commission_type
              && (form.primary_agent_commission_type.value === "fixed_fee" || form.primary_agent_commission_type.value === "both"))
              && (
                <Col>
                  <TextInput
                    name="primary_agent_fixed_fee"
                    label="Agentss Fixed Fee"
                    placeholder="$2,000"
                    isError={errorFields.primary_agent_fixed_fee}
                    value={this.handleDecimalPrice(form.primary_agent_fixed_fee)}
                    onChange={(e) => {
                      this.handleChange(e, deformatCurrency)
                    }}
                  />
                </Col>
              )}
                {/* <Col>
                  <Label
                    style={{
                      width: "759px",
                    }}
                  >
                    Agent Commission Type
                  </Label>
                  <Select
                    name="commission_type"
                    value={Array.isArray(form?.co_listing_agents) && form.co_listing_agents.length > 0 && form.co_listing_agents[0]?.commission_type ? 
                          // If commission_type is a string, find the matching option object
                          (typeof form.co_listing_agents[0].commission_type === 'string' ?
                            COMMISSION_TYPE.find(option => option.value === form.co_listing_agents[0].commission_type) :
                            form.co_listing_agents[0].commission_type) : 
                          form.primary_agent_commission_type}
                    options={COMMISSION_TYPE}
                    onChange={(selectedItem) => {
                      if (Array.isArray(form.co_listing_agents) && form.co_listing_agents.length > 0) {
                        // Create a copy of the array
                        const updatedCoListingAgents = [...form.co_listing_agents];
                        
                        // Update commission_type for the first co-listing agent
                        updatedCoListingAgents[0] = {
                          ...updatedCoListingAgents[0],
                          commission_type: selectedItem.value // Store just the value string
                        };
                        
                        this.setState({
                          form: {
                            ...form,
                            co_listing_agents: updatedCoListingAgents,
                            primary_agent_commission_type: selectedItem.value // Store just the value string
                          }
                        }, () => {
                          console.log("Updated co_listing_agents with commission_type:", this.state.form.co_listing_agents);
                        });
                      } else {
                        // If co_listing_agents is not set or empty, just update the primary_agent_commission_type
                        this.setState({
                          form: {
                            ...form,
                            primary_agent_commission_type: selectedItem.value // Store just the value string
                          }
                        });
                      }
                    }}
                  />
                </Col>
                {(
                  (form.primary_agent_commission_type && form.primary_agent_commission_type.value === "percentage")
                    || (form.primary_agent_commission_type && form.primary_agent_commission_type.value === "both")
                ) && (
                  <Col>
                    <TextInput
                      name="primary_agent_commission_percentage"
                      label="Agent Commission Percentage"
                      typeSymbol="%"
                      placeholder="4%"
                      value={form.primary_agent_commission_split}
                      onChange={this.handleChange}
                      isError={errorFields.primary_agent_commission_split}
                    />
                  </Col>
                )}

                {(form.primary_agent_commission_type
                  && (form.primary_agent_commission_type.value === "fixed_fee" || form.primary_agent_commission_type.value === "both"))
                  && (
                    <Col>
                      <TextInput
                        name="primary_agent_fixed_fee"
                        label="Agent Fixed Fee"
                        placeholder="$2,000"
                        isError={errorFields.fixed_fee}
                        value={Array.isArray(form?.co_listing_agents) && form.co_listing_agents.length > 0 ? 
                              this.handleDecimalPrice(form.co_listing_agents[0]?.fixed_fee) : 
                              (form.fixed_fee === 0 ? this.handleDecimalPrice("0") : this.handleDecimalPrice(form.fixed_fee))}
                        onChange={(e) => {
                          if (Array.isArray(form.co_listing_agents) && form.co_listing_agents.length > 0) {
                            // Create a copy of the array
                            const updatedCoListingAgents = [...form.co_listing_agents];
                            
                            // Update fixed_fee for the first co-listing agent
                            updatedCoListingAgents[0] = {
                              ...updatedCoListingAgents[0],
                              fixed_fee: e.target.value
                            };
                            
                            this.setState({
                              form: {
                                ...form,
                                co_listing_agents: updatedCoListingAgents
                              }
                            }, () => {
                              console.log("Updated co_listing_agents with fixed_fee:", this.state.form.co_listing_agents);
                            });
                          } else {
                            // If co_listing_agents is not set or empty, update the main fixed_fee
                            this.handleChange(e, deformatCurrency);
                          }
                        }}
                      />
                    </Col>
                  )}
                  {(
                    (form.commission_type && form.commission_type.value === "percentage")
                      || (form.commission_type && form.commission_type.value === "both")
                      || true
                  ) && (
                    <Col>
                      <TextInput
                        name="team_split_percentage"
                        label="Team Split %"
                        typeSymbol="%"
                        placeholder="4%"
                        value={form.team_split_percentage}
                        onChange={this.handleChange}
                        isError={errorFields.team_split_percentage}
                      />
                    </Col>
                  )}
                {/* {(
                  (form.commission_type && form.commission_type.value === "percentage")
                    || (form.commission_type && form.commission_type.value === "both")
                    || true
                ) && (
                  <Col>
                    <TextInput
                      name="team_split_percentage"
                      label="Split with Team %"
                      typeSymbol="%"
                      placeholder="4%"
                      value={form.team_split_percentage}
                      onChange={this.handleChange}
                      isError={errorFields.team_split_percentage}
                    />
                  </Col>
                )} 

           </Row> */}
           <Row>
             <Col>
               <Label>
                  Brokerage Fee
               </Label>
               <InputNumber
                 name="brokerage_fee"
                 label="Brokerage Fee"
                 placeholder="$2,000"
                 isError={errorFields.brokerage_fee}
                 /*value={Array.isArray(form?.co_listing_agents) && form.co_listing_agents.length > 0 ? 
                       form.co_listing_agents[0]?.brokerage_fee || 0 : 
                       form.brokerage_fee || 0}*/
                 value = {form.brokerage_fee === 0 ? this.handleDecimalPrice("0") : this.handleDecimalPrice(form.brokerage_fee)}
                 /*onChange={(value) => {
                   if (Array.isArray(form.co_listing_agents) && form.co_listing_agents.length > 0) {
                     // Create a copy of the array
                     const updatedCoListingAgents = [...form.co_listing_agents];
                     
                     // Update brokerage_fee for the first co-listing agent
                     updatedCoListingAgents[0] = {
                       ...updatedCoListingAgents[0],
                       brokerage_fee: value
                     };
                     
                     this.setState({
                       form: {
                         ...form,
                         co_listing_agents: updatedCoListingAgents,
                         brokerage_fee: value // Also update the main form's brokerage_fee
                       }
                     }, () => {
                       console.log("Updated co_listing_agents with brokerage_fee:", this.state.form.co_listing_agents);
                     });
                   } else {
                     // If co_listing_agents is not set or empty, update the main brokerage_fee
                     this.handleChangeNumber(value, "brokerage_fee");
                   }
                 }}*/
                 onChange={(value) => {
                  // this.handleChangeNumber(value, "brokerage_fee");
                  this.handleChangeNumber(value, "brokerage_fee")
                 }}
               />
             </Col>
           </Row>
           {/* <Row>
             <Col>
               <Label>
                  Agent Payout Fee
               </Label>
               <InputNumber
                 name="agent_payout_fee"
                 label="Agent Payout Fee"
                 placeholder="$2,000"
                 isError={errorFields.agent_payout_fee}
                 value={form.agent_payout_fee}
                 onChange={(value) => {
                   this.handleChangeNumber(value, "agent_payout_fee")
                 }}
               />
             </Col>
             <Col>
               <Label>
                  TC Fee
               </Label>
               <InputNumber
                 name="tc_fee"
                 label="TC Fee"
                 placeholder="$2,000"
                 isError={errorFields.tc_fee}
                 value={form.tc_fee}
                 onChange={(value) => {
                   this.handleChangeNumber(value, "tc_fee")
                 }}
               />
             </Col>
           </Row> */}
           <Row>
             <Col>
               <Label>
                  Audit Fee
               </Label>
               <InputNumber
                 name="audit_fee"
                 label="Audit Fee"
                 placeholder="$2,000"
                 isError={errorFields.audit_fee}
                 value={form.audit_fee === 0 ? this.handleDecimalPrice("0") : this.handleDecimalPrice(form.audit_fee)}
                 onChange={(value) => {
                   this.handleChangeNumber(value, "audit_fee")
                 }}
               />
             </Col>
             <Col>
               <Label>
                  Pending Software Fee
               </Label>
               <InputNumber
                 name="pending_subscription_fee"
                 label="Pending Software Fee"
                 placeholder="$2,000"
                 isError={errorFields.pending_subscription_fee}
                 value={form.pending_subscription_fee === 0 ? this.handleDecimalPrice("0") : this.handleDecimalPrice(form.pending_subscription_fee)}
                 onChange={(value) => {
                   this.handleChangeNumber(value, "pending_subscription_fee")
                 }}
               />
             </Col>
           </Row>
           <Row>
             <Col>
               <Label>
                 E&O Fee
               </Label>
               <InputNumber
                 name="e_and_o_fee"
                 label="E&O Fee"
                 placeholder="$2,000"
                 isError={errorFields.e_and_o_fee}
                 value = {form.e_and_o_fee === 0 ? this.handleDecimalPrice("0") : this.handleDecimalPrice(form.e_and_o_fee)}
                 onChange={(value) => {
                  this.handleChangeNumber(value, "e_and_o_fee");
                 }}
               />
             </Col>
             <Col>
               <Label>
                  Internal Referral Fee
               </Label>
               <InputNumber
                 name="referral_fee"
                 label="Referral Fee"
                 placeholder="$2,000"
                 isError={errorFields.referral_fee}
                 value={form.referral_fee === 0 ? this.handleDecimalPrice("0") : this.handleDecimalPrice(form.referral_fee)}
                 onChange={(value) => {
                   this.handleChangeNumber(value, "referral_fee")
                 }}
               />
             </Col>
           </Row>
           <Row>
             <Col>
               <Label>
                  Radius Fee
               </Label>
               <InputNumber
                 name="radius_transaction_fee"
                 label="Radius Fee"
                 placeholder="$2,000"
                 isError={errorFields.radius_transaction_fee}
                 value={form.radius_transaction_fee === 0 ? this.handleDecimalPrice("0") : this.handleDecimalPrice(form.radius_transaction_fee)}
                 onChange={(value) => {
                  this.handleChangeNumber(value, "radius_transaction_fee");
                 }}
               />
             </Col>
           </Row>

           <Row>
            <Col>
              <Label>
                 Miscellaneous Fee
              </Label>
              <InputNumber
                name="misc_fees"
                label="Misc Fee"
                placeholder="$2,000"
                isError={errorFields.misc_fees}
                value={this.formatDisplayValue(form.primary_agent_misc_fees)}
                onChange={(value) => {
                  this.handleChangeNumber(value, "primary_agent_misc_fees");
                }}
              />
            </Col>
          </Row>

          {isEdit && (
            <>
              <Row>
            <Col>
              <Label>
                 Primary Agent Reported Income
              </Label>
              <InputNumber
                name="primary_agent_reported_income"
                label="Primary Agent Reported Income"
                placeholder="$2,000"
                disabled={true}
                isError={errorFields.primary_agent_reported_income}
                value={form.primary_agent_reported_income === 0 ? this.handleDecimalPrice("0") : this.handleDecimalPrice(form.primary_agent_reported_income)}
                onChange={(value) => {
                  this.handleChangeNumber(value, "primary_agent_reported_income");
                }}
              />
            </Col>

            <Col>
              <Label>
                 Primary Agent Net Commission
              </Label>
              <InputNumber
                name="primary_agent_net_commission"
                label="Primary Agent Net Commission"
                disabled={true}
                placeholder="$2,000"
                isError={errorFields.primary_agent_net_commission}
                value={form.primary_agent_net_commission === 0 ? this.handleDecimalPrice("0") : this.handleDecimalPrice(form.primary_agent_net_commission)}
                onChange={(value) => {
                  this.handleChangeNumber(value, "primary_agent_net_commission");
                }}
              />
            </Col>
          </Row>

          {/* <Row>
            <Col>
              <Label>
                 Radius Cap
              </Label>
              <InputNumber
                name="radius_cap"
                label="Radius Cap"
                placeholder="$0"
                disabled={true}
                isError={errorFields.radius_cap}
                value={form.radius_cap === 0 ? this.handleDecimalPrice("0") : this.handleDecimalPrice(form.radius_cap)}
                onChange={(value) => {
                  this.handleChangeNumber(value, "radius_cap");
                }}
              />
            </Col>

            <Col>
              <Label>
                Internal Cap
              </Label>
              <InputNumber
                name="internal_cap"
                label="Internal Cap"
                placeholder="$0"
                disabled={true}
                isError={errorFields.internal_cap}
                value={form.internal_cap === 0 ? this.handleDecimalPrice("0") : this.handleDecimalPrice(form.internal_cap)}
                onChange={(value) => {
                  this.handleChangeNumber(value, "internal_cap");
                }}
              />
            </Col>
          </Row>

          <Row>
            <Col>
              <Label>
                 Progress to Radius Cap
              </Label>
              <InputNumber
                name="progress_to_radius_cap"
                label="Progress to Radius Cap"
                placeholder="$2,000"
                disabled={true}
                isError={errorFields.progress_to_radius_cap}
                value={form.progress_to_radius_cap === 0 ? this.handleDecimalPrice("0") : this.handleDecimalPrice(form.progress_to_radius_cap)}
                onChange={(value) => {
                  this.handleChangeNumber(value, "progress_to_radius_cap");
                }}
              />
            </Col>

            <Col>
              <Label>
                Progress to Internal Cap
              </Label>
              <InputNumber
                name="progress_to_internal_cap_new"
                label="Progress to Internal Cap"
                placeholder="$2,000"
                disabled={true}
                isError={errorFields.progress_to_internal_cap_new}
                value={form.progress_to_internal_cap_new === 0 ? this.handleDecimalPrice("0") : this.handleDecimalPrice(form.progress_to_internal_cap_new)}
                onChange={(value) => {
                  this.handleChangeNumber(value, "progress_to_internal_cap_new");
                }}
              />
            </Col>
          </Row> */}

          {isEdit && (
            <>
              <Row>
                {/* Conditional Rendering for Radius Cap */}
                {(form.radius_cap && parseFloat(form.radius_cap) !== 0 && form?.radius_cap != null) ? (
                  <Col>
                    <Label>Radius Cap</Label>
                    <InputNumber
                      name="radius_cap"
                      label="Radius Cap"
                      placeholder="$0"
                      disabled={true}
                      isError={errorFields.radius_cap}
                      value={form.radius_cap === 0 ? this.handleDecimalPrice("0") : this.handleDecimalPrice(form.radius_cap)}
                      onChange={(value) => {
                        this.handleChangeNumber(value, "radius_cap");
                      }}
                    />
                  </Col>
                ): <></>}

                {/* Conditional Rendering for Internal Cap */}
                {(form.internal_cap && parseFloat(form.internal_cap) !== 0 && form.internal_cap != null) ? (
                  <Col>
                    <Label>Internal Cap</Label>
                    <InputNumber
                      name="internal_cap"
                      label="Internal Cap"
                      placeholder="$0"
                      disabled={true}
                      isError={errorFields.internal_cap}
                      value={form.internal_cap === 0 ? this.handleDecimalPrice("0") : this.handleDecimalPrice(form.internal_cap)}
                      onChange={(value) => {
                        this.handleChangeNumber(value, "internal_cap");
                      }}
                    />
                  </Col>
                ): <></>}
              </Row>

              <Row>
                {(form.radius_cap && form.radius_cap !== 0 && parseFloat(form.radius_cap) !== 0 && form.radius_cap != null) ? (
                  <Col>
                    <Label>Progress to Radius Cap</Label>
                    <InputNumber
                      name="progress_to_radius_cap"
                      label="Progress to Radius Cap"
                      placeholder="$0"
                      // disabled={true}
                      isError={errorFields.progress_to_radius_cap}
                      value={form.progress_to_radius_cap === 0 ? this.handleDecimalPrice("0") : this.handleDecimalPrice(form.progress_to_radius_cap)}
                      onChange={(value) => {
                        this.handleChangeNumber(value, "progress_to_radius_cap");
                      }}
                    />
                  </Col>
                ):<></>}

                {/* Conditional Rendering for Progress to Internal Cap */}
                {(form.internal_cap && parseFloat(form.internal_cap) !== 0 && form.internal_cap != null) ? (
                  <Col>
                    <Label>Progress to Internal Cap</Label>
                    <InputNumber
                      name="progress_to_internal_cap_new"
                      label="Progress to Internal Cap"
                      placeholder="$0"
                      disabled={true}
                      isError={errorFields.progress_to_internal_cap_new}
                      value={form.progress_to_internal_cap_new === 0 ? this.handleDecimalPrice("0") : this.handleDecimalPrice(form.progress_to_internal_cap_new)}
                      onChange={(value) => {
                        this.handleChangeNumber(value, "progress_to_internal_cap_new");
                      }}
                    />
                  </Col>
                ): <></>}
                {(form.internal_cap && parseFloat(form.internal_cap) !== 0 && form.internal_cap != null) ? (
                  <Col>
                    <Label>Remaining to Internal Cap</Label>
                    <InputNumber
                      name="remaining_to_internal_cap_new"
                      label="Remaining to Internal Cap"
                      placeholder="$0"
                      disabled={true}
                      isError={errorFields.remaining_to_internal_cap_new}
                      value={form.remaining_to_internal_cap_new === 0 ? this.handleDecimalPrice("0") : this.handleDecimalPrice(form.remaining_to_internal_cap_new)}
                      onChange={(value) => {
                        this.handleChangeNumber(value, "remaining_to_internal_cap_new");
                      }}
                    />
                  </Col>
                ): <></>}
              </Row>
            </>
          )}
            </>
          )}

         </SectionWrap>
         {form?.co_listing_agents?.length > 0 &&
            !(isObject(form.client_type) ? form.client_type.value === "referral" : form.client_type === "referral") &&
            form.co_listing_agents.map((coAgentItem, agentIndex) => {
              // coAgentItem is an object from this.state.form.co_listing_agents
              if (!coAgentItem) return null; // Defensive check

              // Default display info from co_listing_agents item
              let displayName = `${coAgentItem.firstname || coAgentItem.name || ""} ${coAgentItem.lastname || ""}`.trim();
              let displayEmail = coAgentItem.email || "";

              // If in edit mode and agents_info is available, try to use it for display details
              if (isEdit && form.agents_info && Array.isArray(form.agents_info) && form.agents_info.length > 0) {
                const matchedAgentInfo = form.agents_info.find(
                  ai => ai.agent_id === coAgentItem.agent_id && ai.is_primary === 0
                );
                if (matchedAgentInfo) {
                  const infoDisplayName = `${matchedAgentInfo.firstname || matchedAgentInfo.name || ""} ${matchedAgentInfo.lastname || ""}`.trim();
                  if (infoDisplayName) displayName = infoDisplayName; // Prefer non-empty name from agents_info
                  if (matchedAgentInfo.email) displayEmail = matchedAgentInfo.email; // Prefer email from agents_info
                }
              }

              return (
                <SectionWrap
                  key={coAgentItem.agent_id || `coagent-item-${agentIndex}`}
                  isAnimate={animatePricing}
                  id={`tc-pricing-section-coagent-${coAgentItem.agent_id ||
                    agentIndex}`}
                >
                  <h6>
                    Commission Details (Co agent {agentIndex + 1}:{" "}
                    {displayName || ""} )
                  </h6>
                  <Row noMargin>
                    <Col>
                      <TextInput
                        name={`commission_split_coagent_${coAgentItem.agent_id ||
                          agentIndex}`}
                        label="Co-Agent Split"
                        typeSymbol="%"
                        placeholder="0%"
                        isError={errorFields.commission_split}
                        value={(coAgentItem.commission_split !== undefined &&
                        coAgentItem.commission_split !== null
                          ? coAgentItem.commission_split
                          : ""
                        ).toString()}
                        onChange={(e) =>
                          this.handleCoAgentSplitChange(agentIndex, e)
                        }
                      />
                    </Col>

                    <Col>
                      <TextInput
                        name={`total_agent_commission_${coAgentItem.agent_id ||
                          agentIndex}`}
                        label="Co-agent Commission"
                        placeholder="$0" // Changed placeholder
                        isError={errorFields.total_agent_commission}
                        value={this.roundtTo2(this.handleDecimalPrice(
                          coAgentItem.total_agent_commission
                        ))}
                        disabled
                        onChange={(e) =>
                          this.handleCoAgentTotalCommissionChange(agentIndex, e)
                        }
                      />
                    </Col>
                  </Row>

                  <Row>
                    <Col>
                      <Label style={{ width: "159px" }}>Team Split Type</Label>
                      <Select
                        name={`team_split_type_coagent_${coAgentItem.agent_id ||
                          agentIndex}`}
                        value={
                          coAgentItem.team_split_type
                            ? COMMISSION_TYPE.find(
                                (option) =>
                                  option.value === coAgentItem.team_split_type
                              )
                            : null
                        }
                        options={COMMISSION_TYPE}
                        placeholder="Select Co-Agent Split Type"
                        isClearable={true}
                        onChange={(selectedItem) => {
                          const updatedCoListingAgents = form.co_listing_agents.map(
                            (agent, idx) =>
                              idx === agentIndex
                                ? {
                                    ...agent,
                                    team_split_type:
                                      selectedItem?.value || null,
                                    // Reset dependent fields if type is changed/cleared
                                    team_split_percentage:
                                      selectedItem?.value === "percentage" ||
                                      selectedItem?.value === "both"
                                        ? agent.team_split_percentage !==
                                            undefined &&
                                          agent.team_split_percentage !== null
                                          ? agent.team_split_percentage
                                          : 0
                                        : null,
                                    team_split_fixed_fee:
                                      selectedItem?.value === "fixed_fee" ||
                                      selectedItem?.value === "both"
                                        ? agent.team_split_fixed_fee !==
                                            undefined &&
                                          agent.team_split_fixed_fee !== null
                                          ? agent.team_split_fixed_fee
                                          : 0
                                        : null,
                                  }
                                : agent
                          );
                          this.setState((prevState) => ({
                            form: {
                              ...prevState.form,
                              co_listing_agents: updatedCoListingAgents,
                            },
                          }));
                        }}
                      />
                    </Col>
                    {(coAgentItem.team_split_type === "fixed_fee" ||
                      coAgentItem.team_split_type === "both") && (
                      <>
                        <Col>
                          <TextInput
                            name={`team_split_fixed_fee_coagent_${coAgentItem.agent_id ||
                              agentIndex}`}
                            label="Team Fee"
                            placeholder="$0"
                            isError={errorFields.team_split_fixed_fee}
                            value={this.handleDecimalPrice(
                              coAgentItem.team_split_fixed_fee !== undefined &&
                                coAgentItem.team_split_fixed_fee !== null
                                ? coAgentItem.team_split_fixed_fee
                                : ""
                            )}
                            onChange={(e) => {
                              const rawValue = e.target.value;
                              let valueToSet;
                              if (rawValue === "" || rawValue === "$") {
                                valueToSet = null;
                              } else {
                                const deformatted = deformatCurrency(rawValue);
                                const parsed = deformatted || "";
                                valueToSet = isNaN(parsed)
                                  ? coAgentItem.team_split_fixed_fee !==
                                      undefined &&
                                    coAgentItem.team_split_fixed_fee !== null
                                    ? coAgentItem.team_split_fixed_fee
                                    : 0
                                  : parsed;
                              }

                              const updatedCoListingAgents = form.co_listing_agents.map(
                                (agent, idx) =>
                                  idx === agentIndex
                                    ? {
                                        ...agent,
                                        team_split_fixed_fee: valueToSet,
                                        total_agent_team_commission: this.calculateCoAgentTeamCommission(
                                          agent.team_split_type,
                                          agent.team_split_percentage,
                                          valueToSet,
                                          agent.total_agent_commission
                                        ),
                                      }
                                    : agent
                              );

                              this.setState((prevState) => ({
                                form: {
                                  ...prevState.form,
                                  co_listing_agents: updatedCoListingAgents,
                                },
                              }));
                            }}
                          />
                        </Col>
                      </>
                    )}

                    {(coAgentItem.team_split_type === "percentage" ||
                      coAgentItem.team_split_type === "both") && (
                      <>
                        <Col>
                          <TextInput
                            name={`team_split_percentage_coagent_${coAgentItem.agent_id ||
                              agentIndex}`}
                            label="Team Split"
                            typeSymbol="%"
                            placeholder="0%"
                            value={(coAgentItem.team_split_percentage !==
                              undefined &&
                            coAgentItem.team_split_percentage !== null
                              ? coAgentItem.team_split_percentage
                              : ""
                            ).toString()}
                            onChange={(e) =>
                              this.handleCoAgentTeamSplitPercentageChange(
                                agentIndex,
                                e
                              )
                            } // Use new handler
                            isError={
                              errorFields[
                                `team_split_percentage_coagent_${coAgentItem.agent_id ||
                                  agentIndex}`
                              ]
                            } // Ensure error field name matches if you have individual errors
                          />
                        </Col>
                      </>
                    )}
                    <Col>
                      <TextInput
                        name={`total_agent_team_commission_coagent_${coAgentItem.agent_id ||
                          agentIndex}`}
                        label="Total Co-Agent Team Commission"
                        placeholder="$0"
                        value={this.roundtTo2(this.handleDecimalPrice(
                          coAgentItem.total_agent_team_commission
                        ))}
                        onChange={(e) =>
                          this.handleCoAgentTeamSplitPercentageChange(
                            agentIndex,
                            e
                          )
                        } // Use new handler
                        isError={
                          errorFields[
                            `total_agent_team_commission_coagent_${coAgentItem.agent_id ||
                              agentIndex}`
                          ]
                        } // Ensure error field name matches
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Label>Contribution to Cap</Label>
                      <InputNumber
                        name={`contribution_to_internal_cap_manual_coagent_${coAgentItem.agent_id || agentIndex}`}
                        placeholder="$0"
                        value={
                          coAgentItem.contribution_to_internal_cap_manual === null
                          || coAgentItem.contribution_to_internal_cap_manual === undefined
                            ? undefined
                            : Number(coAgentItem.contribution_to_internal_cap_manual)
                        }
                        formatter={(v) => (v === undefined || v === null ? "" : `$${v}`)}
                        parser={(v) => (v === undefined || v === null || v === "$" ? null : v.replace(/\$\s?|(,*)/g, ""))}
                        onChange={(value) => this.handleCoAgentContributionToCapManualChange(agentIndex, value)}
                      />
                    </Col>
                  </Row>

                  {/* Fee InputNumber fields - ensuring value is undefined if null for antd placeholder */}
                  <Row>
                    <Col>
                      <Label>Brokerage Fee</Label>
                      <InputNumber
                        name={`brokerage_fee_coagent_${coAgentItem.agent_id ||
                          agentIndex}`}
                        placeholder="$0"
                        value={
                          coAgentItem.brokerage_fee === null ||
                          coAgentItem.brokerage_fee === undefined
                            ? undefined
                            : this.truncateToTwoDecimals(coAgentItem.brokerage_fee)
                        }
                        formatter={(value) =>
                          value === undefined || value === null
                            ? ""
                            : `$${value}`
                        }
                        parser={(value) =>
                          value === undefined || value === null || value === "$"
                            ? null
                            : value.replace(/\$\s?|(,*)/g, "")
                        }
                        onChange={(newValue) => {
                          const updatedCoListingAgents = form.co_listing_agents.map(
                            (agent, idx) =>
                              idx === agentIndex
                                ? {
                                    ...agent,
                                    brokerage_fee:
                                      newValue === null
                                        ? null
                                        : Number(newValue) || 0,
                                  }
                                : agent
                          );
                          this.setState(
                            (prevState) => ({
                              form: {
                                ...prevState.form,
                                co_listing_agents: updatedCoListingAgents,
                              },
                            }),
                            () => {
                              if (agentIndex < form.co_listing_agents.length)
                                this.calculateCoAgentRadiusFee(agentIndex);
                            }
                          );
                        }}
                      />
                    </Col>
                  </Row>

                  <Row>
                    <Col>
                      <Label>Audit Fee</Label>
                      <InputNumber
                        name={`audit_fee_coagent_${coAgentItem.agent_id ||
                          agentIndex}`}
                        placeholder="$0"
                        value={
                          coAgentItem.audit_fee === null ||
                          coAgentItem.audit_fee === undefined
                            ? undefined
                            : this.truncateToTwoDecimals(coAgentItem.audit_fee)
                        }
                        formatter={(value) =>
                          value === undefined || value === null
                            ? ""
                            : `$${value}`
                        }
                        parser={(value) =>
                          value === undefined || value === null || value === "$"
                            ? null
                            : value.replace(/\$\s?|(,*)/g, "")
                        }
                        onChange={(newValue) => {
                          const updatedCoListingAgents = form.co_listing_agents.map(
                            (agent, idx) =>
                              idx === agentIndex
                                ? {
                                    ...agent,
                                    audit_fee:
                                      newValue === null
                                        ? null
                                        : Number(newValue) || 0,
                                  }
                                : agent
                          );
                          this.setState(
                            (prevState) => ({
                              form: {
                                ...prevState.form,
                                co_listing_agents: updatedCoListingAgents,
                              },
                            }),
                            () => {
                              if (agentIndex < form.co_listing_agents.length)
                                this.calculateCoAgentRadiusFee(agentIndex);
                            }
                          );
                        }}
                      />
                    </Col>
                    <Col>
                      <Label>Pending Software Fee</Label>
                      <InputNumber
                        name={`pending_subscription_fee_coagent_${coAgentItem.agent_id ||
                          agentIndex}`}
                        placeholder="$0"
                        value={
                          coAgentItem.pending_subscription_fee === null ||
                          coAgentItem.pending_subscription_fee === undefined
                            ? undefined
                            : this.truncateToTwoDecimals(coAgentItem.pending_subscription_fee)
                        }
                        formatter={(value) =>
                          value === undefined || value === null
                            ? ""
                            : `$${value}`
                        }
                        parser={(value) =>
                          value === undefined || value === null || value === "$"
                            ? null
                            : value.replace(/\$\s?|(,*)/g, "")
                        }
                        onChange={(newValue) => {
                          const updatedCoListingAgents = form.co_listing_agents.map(
                            (agent, idx) =>
                              idx === agentIndex
                                ? {
                                    ...agent,
                                    pending_subscription_fee:
                                      newValue === null
                                        ? null
                                        : Number(newValue) || 0,
                                  }
                                : agent
                          );
                          this.setState(
                            (prevState) => ({
                              form: {
                                ...prevState.form,
                                co_listing_agents: updatedCoListingAgents,
                              },
                            }),
                            () => {
                              if (agentIndex < form.co_listing_agents.length)
                                this.calculateCoAgentRadiusFee(agentIndex);
                            }
                          );
                        }}
                      />
                    </Col>
                  </Row>

                  <Row>
                    <Col>
                      <Label>E&O Fee</Label>
                      <InputNumber
                        name={`eno_fee_coagent_${coAgentItem.agent_id ||
                          agentIndex}`}
                        placeholder="$0"
                        value={
                          coAgentItem.eno_fee === null ||
                          coAgentItem.eno_fee === undefined
                            ? undefined
                            : this.truncateToTwoDecimals(coAgentItem.eno_fee)
                        }
                        formatter={(value) =>
                          value === undefined || value === null
                            ? ""
                            : `$${value}`
                        }
                        parser={(value) =>
                          value === undefined || value === null || value === "$"
                            ? null
                            : value.replace(/\$\s?|(,*)/g, "")
                        }
                        onChange={(newValue) => {
                          const updatedCoListingAgents = form.co_listing_agents.map(
                            (agent, idx) =>
                              idx === agentIndex
                                ? {
                                    ...agent,
                                    eno_fee:
                                      newValue === null
                                        ? null
                                        : Number(newValue) || 0,
                                  }
                                : agent
                          );
                          this.setState(
                            (prevState) => ({
                              form: {
                                ...prevState.form,
                                co_listing_agents: updatedCoListingAgents,
                              },
                            }),
                            () => {
                              if (agentIndex < form.co_listing_agents.length)
                                this.calculateCoAgentRadiusFee(agentIndex);
                            }
                          );
                        }}
                      />
                    </Col>
                    <Col>
                      <Label>Internal Referral Fee</Label>
                      <InputNumber
                        name={`internal_referral_fee_coagent_${coAgentItem.agent_id ||
                          agentIndex}`}
                        placeholder="$0"
                        value={
                          coAgentItem.internal_referral_fee === null ||
                          coAgentItem.internal_referral_fee === undefined
                            ? undefined
                            : this.truncateToTwoDecimals(coAgentItem.internal_referral_fee)
                        }
                        formatter={(value) =>
                          value === undefined || value === null
                            ? ""
                            : `$${value}`
                        }
                        parser={(value) =>
                          value === undefined || value === null || value === "$"
                            ? null
                            : value.replace(/\$\s?|(,*)/g, "")
                        }
                        onChange={(newValue) => {
                          const updatedCoListingAgents = form.co_listing_agents.map(
                            (agent, idx) =>
                              idx === agentIndex
                                ? {
                                    ...agent,
                                    internal_referral_fee:
                                      newValue === null
                                        ? null
                                        : Number(newValue) || 0,
                                  }
                                : agent
                          );
                          this.setState(
                            (prevState) => ({
                              form: {
                                ...prevState.form,
                                co_listing_agents: updatedCoListingAgents,
                              },
                            }),
                            () => {
                              if (agentIndex < form.co_listing_agents.length)
                                this.calculateCoAgentRadiusFee(agentIndex);
                            }
                          );
                        }}
                      />
                    </Col>
                  </Row>

                  <Row>
                    <Col>
                      <Label>Radius Fee</Label>
                      <InputNumber
                        name={`radius_fee_coagent_${coAgentItem.agent_id ||
                          agentIndex}`}
                        placeholder="$0"
                        value={
                          coAgentItem.radius_fee === null ||
                          coAgentItem.radius_fee === undefined
                            ? undefined
                            : this.truncateToTwoDecimals(parseFloat(coAgentItem.radius_fee))
                        }
                        formatter={(value) =>
                          value === undefined || value === null
                            ? ""
                            : `$${value}`
                        }
                        parser={(value) =>
                          value === undefined || value === null || value === "$"
                            ? null
                            : value.replace(/\$\s?|(,*)/g, "")
                        }
                        disabled={true}
                        style={{ color: "rgba(0, 0, 0, 0.85)" }}
                      />
                    </Col>
                  </Row>

                  <Row>
                    <Col>
                      <Label>Miscellaneous Fee</Label>
                      <InputNumber
                        name={`misc_fees_coagent_${coAgentItem.agent_id ||
                          agentIndex}`}
                        placeholder="$0"
                        value={
                          coAgentItem.misc_fees === null ||
                          coAgentItem.misc_fees === undefined
                            ? undefined
                            : this.truncateToTwoDecimals(parseFloat(coAgentItem.misc_fees))
                        }
                        formatter={(value) =>
                          value === undefined || value === null
                            ? ""
                            : `$${value}`
                        }
                        parser={(value) =>
                          value === undefined || value === null || value === "$"
                            ? null
                            : value.replace(/\$\s?|(,*)/g, "")
                        }
                        onChange={(newValue) => {
                          const updatedCoListingAgents = form.co_listing_agents.map(
                            (agent, idx) =>
                              idx === agentIndex
                                ? {
                                    ...agent,
                                    misc_fees:
                                      newValue === null
                                        ? null
                                        : Number(newValue) || 0,
                                  }
                                : agent
                          );
                          this.setState((prevState) => ({
                            form: {
                              ...prevState.form,
                              co_listing_agents: updatedCoListingAgents,
                            },
                          }));
                        }}
                      />
                    </Col>
                  </Row>

                  {isEdit && (
                    <>
                      <Row>
                        <Col>
                          <Label>Co Agent Reported Income</Label>
                          <InputNumber
                            name={`agent_reported_income_coagent_${coAgentItem.agent_id ||
                              agentIndex}`}
                            placeholder="$0"
                            disabled={true}
                            value={
                              coAgentItem.agent_reported_income === null ||
                              coAgentItem.agent_reported_income === undefined
                                ? undefined
                                : `$${parseFloat(coAgentItem.agent_reported_income).toFixed(2)}`
                            }
                            // formatter={value => (value === undefined || value === null) ? '' : `$${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                         
                            parser={(value) =>
                              value === undefined ||
                              value === null ||
                              value === "$"
                                ? null
                                : value.replace(/\$\s?|(,*)/g, "")
                            }
                            onChange={(newValue) => {
                              const updatedCoListingAgents = form.co_listing_agents.map(
                                (agent, idx) =>
                                  idx === agentIndex
                                    ? {
                                        ...agent,
                                        agent_reported_income:
                                          newValue === null
                                            ? null
                                            : Number(newValue) || 0,
                                      }
                                    : agent
                              );
                              this.setState((prevState) => ({
                                form: {
                                  ...prevState.form,
                                  co_listing_agents: updatedCoListingAgents,
                                },
                              }));
                            }}
                          />
                        </Col>
                        <Col>
                          <Label>Co Agent Net Commission</Label>
                          <InputNumber
                            name={`co_agent_net_commission_coagent_${coAgentItem.agent_id ||
                              agentIndex}`}
                            placeholder="$0"
                            disabled={true}
                            value={
                              coAgentItem.agent_net_commission === null ||
                              coAgentItem.agent_net_commission === undefined
                                ? undefined
                                : `$${parseFloat(coAgentItem.agent_net_commission).toFixed(2)}`
                            }
                         
                            parser={(value) =>
                              value === undefined ||
                              value === null ||
                              value === "$"
                                ? null
                                : value.replace(/\$\s?|(,*)/g, "")
                            }
                            onChange={(newValue) => {
                              const updatedCoListingAgents = form.co_listing_agents.map(
                                (agent, idx) =>
                                  idx === agentIndex
                                    ? {
                                        ...agent,
                                        agent_net_commission:
                                          newValue === null
                                            ? null
                                            : Number(newValue) || 0,
                                      }
                                    : agent
                              );
                              this.setState((prevState) => ({
                                form: {
                                  ...prevState.form,
                                  co_listing_agents: updatedCoListingAgents,
                                },
                              }));
                            }}
                          />
                        </Col>
                      </Row>

                      {/* <Row>
                        <Col>
                          <Label>Radius Cap</Label>
                          <InputNumber
                            name={`radius_cap_coagent_${coAgentItem.agent_id || agentIndex}`}
                            placeholder="$0"
                            disabled={true}
                            value={coAgentItem.radius_cap === null || coAgentItem.radius_cap === undefined ? undefined : parseFloat(coAgentItem.radius_cap)}
                            formatter={value => (value === undefined || value === null) ? '' : `$${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            parser={value => (value === undefined || value === null || value === '$') ? null : value.replace(/\$\s?|(,*)/g, '')}
                            onChange={(newValue) => {
                              const updatedCoListingAgents = form.co_listing_agents.map((agent, idx) => 
                                idx === agentIndex ? { ...agent, radius_cap: newValue === null ? null : (Number(newValue) || 0) } : agent
                              );
                              this.setState(prevState => ({
                                form: { ...prevState.form, co_listing_agents: updatedCoListingAgents }
                              }));
                            }}
                          />
                        </Col>
                        <Col>
                          <Label>Internal Cap</Label>
                          <InputNumber
                            name={`internal_cap_coagent_${coAgentItem.agent_id || agentIndex}`}
                            placeholder="$0"
                            disabled={true}
                            value={coAgentItem.internal_cap === null || coAgentItem.internal_cap === undefined ? undefined : parseFloat(coAgentItem.internal_cap)}
                            formatter={value => (value === undefined || value === null) ? '' : `$${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            parser={value => (value === undefined || value === null || value === '$') ? null : value.replace(/\$\s?|(,*)/g, '')}
                            onChange={(newValue) => {
                              const updatedCoListingAgents = form.co_listing_agents.map((agent, idx) => 
                                idx === agentIndex ? { ...agent, internal_cap: newValue === null ? null : (Number(newValue) || 0) } : agent
                              );
                              this.setState(prevState => ({
                                form: { ...prevState.form, co_listing_agents: updatedCoListingAgents }
                              }));
                            }}
                          />
                        </Col>
                      </Row>

                      <Row>
                        <Col>
                          <Label>Progress to Radius Cap</Label>
                          <InputNumber
                            name={`progress_to_radius_cap_coagent_${coAgentItem.agent_id || agentIndex}`}
                            placeholder="$0"
                            disabled={true}
                            value={coAgentItem.progress_to_radius_cap === null || coAgentItem.progress_to_radius_cap === undefined ? undefined : parseFloat(coAgentItem.progress_to_radius_cap)}
                            formatter={value => (value === undefined || value === null) ? '' : `$${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            parser={value => (value === undefined || value === null || value === '$') ? null : value.replace(/\$\s?|(,*)/g, '')}
                            onChange={(newValue) => {
                              const updatedCoListingAgents = form.co_listing_agents.map((agent, idx) => 
                                idx === agentIndex ? { ...agent, progress_to_radius_cap: newValue === null ? null : (Number(newValue) || 0) } : agent
                              );
                              this.setState(prevState => ({
                                form: { ...prevState.form, co_listing_agents: updatedCoListingAgents }
                              }));
                            }}
                          />
                        </Col>
                        <Col>
                          <Label>Progress to Internal Cap</Label>
                          <InputNumber
                            name={`progress_to_internal_cap_new_coagent_${coAgentItem.agent_id || agentIndex}`}
                            placeholder="$0"
                            disabled={true}
                            value={coAgentItem.progress_to_internal_cap_new === null || coAgentItem.progress_to_internal_cap_new === undefined ? undefined : parseFloat(coAgentItem.progress_to_internal_cap_new)}
                            formatter={value => (value === undefined || value === null) ? '' : `$${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            parser={value => (value === undefined || value === null || value === '$') ? null : value.replace(/\$\s?|(,*)/g, '')}
                            onChange={(newValue) => {
                              const updatedCoListingAgents = form.co_listing_agents.map((agent, idx) => 
                                idx === agentIndex ? { ...agent, progress_to_internal_cap_new: newValue === null ? null : (Number(newValue) || 0) } : agent
                              );
                              this.setState(prevState => ({
                                form: { ...prevState.form, co_listing_agents: updatedCoListingAgents }
                              }));
                            }}
                          />
                        </Col>
                      </Row> */}
                      {isEdit && (
                        <>
                          <Row>
                            {/* Conditional Rendering for Co-Agent Radius Cap */}
                            {coAgentItem.radius_cap &&
                              parseFloat(coAgentItem.radius_cap) !== 0 && (
                                <Col>
                                  <Label>Radius Cap</Label>
                                  <InputNumber
                                    name={`radius_cap_coagent_${coAgentItem.agent_id ||
                                      agentIndex}`}
                                    placeholder="$0"
                                    disabled={true}
                                    value={
                                      coAgentItem.radius_cap === null ||
                                      coAgentItem.radius_cap === undefined
                                        ? undefined
                                        : parseFloat(coAgentItem.radius_cap)
                                    }
                                    formatter={(value) =>
                                      value === undefined || value === null
                                        ? ""
                                        : `$${value}`.replace(
                                            /\B(?=(\d{3})+(?!\d))/g,
                                            ","
                                          )
                                    }
                                    parser={(value) =>
                                      value === undefined ||
                                      value === null ||
                                      value === "$"
                                        ? null
                                        : value.replace(/\$\s?|(,*)/g, "")
                                    }
                                    onChange={(value) => {
                                      this.handleChangeNumber(
                                        value,
                                        "radius_cap"
                                      );
                                    }}
                                  />
                                </Col>
                              )}

                            {/* Conditional Rendering for Co-Agent Internal Cap */}
                            {coAgentItem.internal_cap &&
                              parseFloat(coAgentItem.internal_cap) !== 0 && (
                                <Col>
                                  <Label>Internal Cap</Label>
                                  <InputNumber
                                    name={`internal_cap_coagent_${coAgentItem.agent_id ||
                                      agentIndex}`}
                                    placeholder="$0"
                                    disabled={true}
                                    value={
                                      coAgentItem.internal_cap === null ||
                                      coAgentItem.internal_cap === undefined
                                        ? undefined
                                        : parseFloat(coAgentItem.internal_cap)
                                    }
                                    formatter={(value) =>
                                      value === undefined || value === null
                                        ? ""
                                        : `$${value}`.replace(
                                            /\B(?=(\d{3})+(?!\d))/g,
                                            ","
                                          )
                                    }
                                    parser={(value) =>
                                      value === undefined ||
                                      value === null ||
                                      value === "$"
                                        ? null
                                        : value.replace(/\$\s?|(,*)/g, "")
                                    }
                                    onChange={(value) => {
                                      this.handleChangeNumber(
                                        value,
                                        "internal_cap"
                                      );
                                    }}
                                  />
                                </Col>
                              )}
                          </Row>

                          <Row>
                            {/* Conditional Rendering for Co-Agent Progress to Radius Cap */}
                            {coAgentItem.radius_cap &&
                              parseFloat(coAgentItem.radius_cap) !== 0 && (
                                <Col>
                                  <Label>Progress to Radius Cap</Label>
                                  <InputNumber
                                    name={`progress_to_radius_cap_coagent_${coAgentItem.agent_id ||
                                      agentIndex}`}
                                    placeholder="$0"
                                    disabled={true}
                                    value={
                                      coAgentItem.progress_to_radius_cap ===
                                        null ||
                                      coAgentItem.progress_to_radius_cap ===
                                        undefined
                                        ? undefined
                                        : parseFloat(
                                            coAgentItem.progress_to_radius_cap
                                          )
                                    }
                                    formatter={(value) =>
                                      value === undefined || value === null
                                        ? ""
                                        : `$${value}`.replace(
                                            /\B(?=(\d{3})+(?!\d))/g,
                                            ","
                                          )
                                    }
                                    parser={(value) =>
                                      value === undefined ||
                                      value === null ||
                                      value === "$"
                                        ? null
                                        : value.replace(/\$\s?|(,*)/g, "")
                                    }
                                    onChange={(value) => {
                                      this.handleChangeNumber(
                                        value,
                                        "progress_to_radius_cap"
                                      );
                                    }}
                                  />
                                </Col>
                              )}

                            {/* Conditional Rendering for Co-Agent Progress to Internal Cap */}
                            {coAgentItem.internal_cap &&
                              parseFloat(coAgentItem.internal_cap) !== 0 && (
                                <Col>
                                  <Label>Progress to Internal Cap</Label>
                                  <InputNumber
                                    name={`progress_to_internal_cap_new_coagent_${coAgentItem.agent_id ||
                                      agentIndex}`}
                                    placeholder="$0"
                                    disabled={true}
                                    value={
                                      coAgentItem.progress_to_internal_cap_new ===
                                        null ||
                                      coAgentItem.progress_to_internal_cap_new ===
                                        undefined
                                        ? undefined
                                        : parseFloat(
                                            coAgentItem.progress_to_internal_cap_new
                                          )
                                    }
                                    formatter={(value) =>
                                      value === undefined || value === null
                                        ? ""
                                        : `$${value}`.replace(
                                            /\B(?=(\d{3})+(?!\d))/g,
                                            ","
                                          )
                                    }
                                    parser={(value) =>
                                      value === undefined ||
                                      value === null ||
                                      value === "$"
                                        ? null
                                        : value.replace(/\$\s?|(,*)/g, "")
                                    }
                                    onChange={(value) => {
                                      this.handleChangeNumber(
                                        value,
                                        "progress_to_internal_cap_new"
                                      );
                                    }}
                                  />
                                </Col>
                              )}
                            {coAgentItem.internal_cap &&
                              parseFloat(coAgentItem.internal_cap) !== 0 && (
                                <Col>
                                  <Label>Remaining to Internal Cap</Label>
                                  <InputNumber
                                    name={`remaining_to_internal_cap_new_coagent_${coAgentItem.agent_id ||
                                      agentIndex}`}
                                    placeholder="$0"
                                    disabled={true}
                                    value={
                                      coAgentItem.remaining_to_internal_cap_new ===
                                        null ||
                                      coAgentItem.remaining_to_internal_cap_new ===
                                        undefined
                                        ? undefined
                                        : parseFloat(
                                            coAgentItem.remaining_to_internal_cap_new
                                          )
                                    }
                                    formatter={(value) =>
                                      value === undefined || value === null
                                        ? ""
                                        : `$${value}`.replace(
                                            /\B(?=(\d{3})+(?!\d))/g,
                                            ","
                                          )
                                    }
                                    parser={(value) =>
                                      value === undefined ||
                                      value === null ||
                                      value === "$"
                                        ? null
                                        : value.replace(/\$\s?|(,*)/g, "")
                                    }
                                  />
                                </Col>
                              )}
                          </Row>
                        </>
                      )}
                    </>
                  )}
                </SectionWrap>
              );
            })}
         <SectionWrap>
           <h6>
             Listing/Deal Details
           </h6>
           {/* {form.file_type && form.file_type.value === "new_listing" && (
             <Row noMargin>
               <Col>
                 <Label>
                  Active Listing Status
                 </Label>
                 <Select
                   name="active_listing_status"
                   placeholder="Active Listing Status"
                   options={[
                     { label: "Active Listing", value: "active_listing" },
                     { label: "In-Contract", value: "in_contract" },
                     { label: "Closed", value: "closed" },
                     { label: "Pending", value: "pending" },
                     { label: "Cancelled", value: "cancelled" },
                   ]}
                   value={form.active_listing_status}
                   onChange={(selectedItem) => {
                     this.setState({
                       form: {
                         ...form,
                         active_listing_status: selectedItem,
                       },
                     })
                   }}
                 />
               </Col>
             </Row>
           )} */}
           <Row>
             <Col>
               <Label>
                Would you like to use our Radius in-house TC for this transaction?
               </Label>
               <Select
                 name="is_using_deal_tc"
                 placeholder={form.is_using_deal_tc === null ? " Yes/No " : form.is_using_deal_tc === 1 ? "Yes" : "No"}
                 defaultValue={form.is_using_deal_tc === null ? " - " : form.is_using_deal_tc === 1 ? "Yes" : "No"}
                 required
                 options={dealTCOptions}
                 onChange={(selectedItem) => {
                   this.setState({
                     form: {
                       ...form,
                       is_using_deal_tc: selectedItem,
                     },
                   })
                 }}
                 value={form.is_using_deal_tc}
               />
               {(
                 form.is_using_deal_tc && form.is_using_deal_tc.value === 0
                 || form.is_using_deal_tc && form.is_using_deal_tc === undefined
               ) && (
                 <TCDetails>
                   <Col>
                     <TextInput
                       label="External TC Name"
                       name="tc_name"
                       placeholder="Name"
                       value={form.tc_name}
                       onChange={this.handleChange}
                       isError={errorFields.tc_name}
                     />
                   </Col>
                   <Col>
                     <TextInput
                       label="External TC Email"
                       name="tc_email"
                       placeholder="Email"
                       value={form.tc_email}
                       onChange={this.handleChange}
                       isError={errorFields.tc_email}
                     />
                   </Col>
                   <Col>
                     <TextInput
                       label="External TC Phone"
                       name="tc_phone"
                       placeholder="+1 1234566789"
                       value={form.tc_phone}
                       onChange={this.handleChange}
                       isError={errorFields.tc_phone}
                     />
                   </Col>
                 </TCDetails>
               )}
             </Col>
           </Row>
           {isEdit && (
             <Row>
                  <>
                    <Col>
                      <Label>
                Would you like to apply the offer coupon for this transaction?
                      </Label>
                      <Select
                        name="is_coupon_applied"
                        placeholder="No"
                        defaultValue={0}
                        required
                        options={dealTCOptions}
                        onChange={(selectedItem) => {
                          this.setState({
                            form: {
                              ...form,
                              is_coupon_applied: selectedItem,
                            },
                          })
                        }}
                        value={form.is_coupon_applied}
                      />
                    </Col>
                  </>
             </Row>
           )}
           {isEdit && (
            <Row>
            <Col>
              <Label>
                Is this transaction an all cash offer?
              </Label>
              <Select
                name="is_all_cash_offer"
                placeholder="Yes/No"
                required
                options={[
                  { label: "Yes", value: 1 },
                  { label: "No", value: 0 },
                ]}
                value={form.is_all_cash_offer}
                onChange={(selectedItem) => {
                  this.setState({
                    form: {
                      ...form,
                      is_all_cash_offer: selectedItem,
                    },
                  })
                }}
              />
            </Col>
          </Row>
           )}
           {this.boolCheck(form.is_all_cash_offer) === 0 && (
             <Row>
               <Col>
                 <TextInput
                   label="Lender Email Address"
                   name="lender_email_address"
                   placeholder="biju@ad.com"
                   value={form.lender_email_address}
                   onChange={this.handleChange}
                   isError={errorFields.lender_email_address}
                 />
               </Col>
             </Row>
           )}
         </SectionWrap>

         {(form.file_type
         && (
           form.file_type.value === "pending_contract"
           || form.file_type.value === "external_referral_agreement"
           || form.file_type.value === "dual"
         ) && (
           form.is_using_deal_tc
          && (
            form.is_using_deal_tc.value === 1
          )
         )
         ) && (
           <SectionWrap>
             <h6>
             Escrow/Pre-Escrow
             </h6>
             <Row isEscrow noMargin>
               <Col>
                 <Label>
                 Radius TC to Open Escrow?
                 </Label>
                 <Select
                   name="is_radius_tc_to_open_escrow"
                   placeholder="Yes/No"
                   defaultValue={{ label: "Yes", value: 1 }}
                   options={[
                     { label: "Yes", value: 1 },
                     { label: "No", value: 0 },
                   ]}
                   value={form.is_radius_tc_to_open_escrow}
                   onChange={(selectedItem) => {
                     this.setState({
                       form: {
                         ...form,
                         is_radius_tc_to_open_escrow: selectedItem,
                       },
                     })
                   }}
                 />
               </Col>
               {(
                 form.is_radius_tc_to_open_escrow && form.is_radius_tc_to_open_escrow.value === 1
              || form.is_radius_tc_to_open_escrow && form.is_radius_tc_to_open_escrow === undefined
               ) && (
                <>
                  {ListValues.ListValues.length === 0 ? (
                    <>
                      <AntdButton
                        type="primary"
                        onClick={() => {
                          setEscrowEdit(null)
                          toggleEscrowDrawer(true)
                        }}
                        style={{
                          marginBottom: "10px",
                          width: "250px",
                        }}
                      >
                    Add new Escrow Details
                      </AntdButton>
                      <EscrowDrawer agentId={agentId} />
                    </>
                  ) : (
                    <>
                      <EscrowWrap>
                        <TitleWrap>
                          <Title>
                            Escrow and Title Information
                          </Title>
                          <AntdButton
                            type="primary"
                            onClick={() => {
                              setEscrowEdit(null)
                              toggleEscrowDrawer(true)
                            }}
                            style={{
                              marginBottom: "10px",
                              width: "250px",
                            }}
                          >
                    Add new Escrow Details
                          </AntdButton>
                        </TitleWrap>
                        {allVendors && (
                          <List
                            dataSource={allVendors}
                            itemLayout="horizontal"
                            renderItem={item => (
                              <List.Item
                                actions={[
                                  <AntdButton
                                    type="primary"
                                    onClick={() => {
                                      toggleEscrowDrawer(true)
                                      setEscrowEdit(item.id)
                                    }}
                                  >
                                  Edit
                                  </AntdButton>,
                                  <>
                                    {(selectedId === item.id || allVendors.indexOf(item) === isSelected) ? (
                                      <SelectedButton
                                        type="primary"
                                      >
                                    Selected
                                      </SelectedButton>
                                    ) : (
                                      <SelectedButton
                                        type="default"
                                        onClick={() => {
                                          if (item.id) {
                                            setSelectedId(item.id)
                                            this.setState({
                                              isSelected: null,
                                            })
                                          } else {
                                            item.is_selected = true
                                            const index = allVendors.indexOf(item)
                                            const a = allVendors.map((x) => {
                                              if (x.is_selected && x !== item) {
                                                delete x.is_selected
                                              } else if (x.is_selected && x === item) {
                                                this.setState({
                                                  isSelected: index,
                                                })
                                                setSelectedId(null)
                                              }
                                            })
                                          }
                                        }}
                                      >
                                      Select
                                      </SelectedButton>
                                    )}
                                  </>,
                                ]}
                              >
                                <List.Item.Meta
                                  title={<h4>{this.formatTitle(item.vendor_type)}</h4>}
                                  description={(
                                    <InfoWrap>
                                      <VendorLabel>{item.vendor_name}</VendorLabel>
                                      <VendorLabel>{item.vendor_number}</VendorLabel>
                                      <VendorLabel>
                                        {item.vendor_officer_first_name}
                                        {" "}
                                        {item.vendor_officer_last_name}
                                      </VendorLabel>
                                      <VendorLabel>
                                        {item.vendor_address}
                                        {", "}
                                        {item.vendor_city}
                                        {", "}
                                        {item.vendor_state}
                                        {"  "}
                                        {item.vendor_zipcode}
                                      </VendorLabel>
                                      <VendorLabel>{item.vendor_email}</VendorLabel>
                                    </InfoWrap>
                                  )}
                                />
                              </List.Item>
                            )}
                          />
                        )}
                      </EscrowWrap>
                    </>
                  ) }
                  <EscrowDrawer agentId={agentId} />
                </>
               )}
             </Row>
           </SectionWrap>
         )}
         {/* {form.file_type && form.file_type.value === "new_listing" && (
           <SectionWrap>
             <h6>
             Sign and Post Installation
             </h6>
             <Row noMargin>
               <Col>
                 <Label>
                  Are you requesting sign post installation?
                 </Label>
                 <Select
                   name="schedule_sign_post_installation"
                   placeholder="Yes/No"
                   options={[
                     { label: "Yes", value: 1 },
                     { label: "No", value: 0 },
                   ]}
                   value={form.schedule_sign_post_installation}
                   onChange={(selectedItem) => {
                     this.setState({
                       form: {
                         ...form,
                         schedule_sign_post_installation: selectedItem,
                       },
                     })
                   }}
                 />
               </Col>
             </Row>
             {(form.schedule_sign_post_installation
              && form.schedule_sign_post_installation.value === 1) ? (
              <>
                <Row>
                  <Col>
                    <TextInput
                      fullWidth
                      name="sign_post_installation_on"
                      label="Sign Post Installation On"
                      placeholder={moment(new Date()).format("D MMM, YYYY")}
                      type="date"
                      value={moment.unix(form.sign_post_installation_on || nowTime).format("YYYY-MM-DD")}
                      isError={errorFields.sign_post_installation_on}
                      onChange={(e) => {
                        this.setState({
                          form: {
                            ...form,
                            sign_post_installation_on: moment(e.target.value).unix(),
                          },
                        })
                      }}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <TextInput
                      fullWidth
                      label="If riders are necessary, please specify"
                      name="sign_post_installation_riders"
                      placeholder="Rider info"
                      value={form.sign_post_installation_riders}
                      onChange={this.handleChange}
                      isError={errorFields.sign_post_installation_riders}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <TextInput
                      fullWidth
                      label="What is the specific location where the sign should be installed?"
                      name="sign_post_installation_location"
                      placeholder="Front yard, backback yard, etc."
                      value={form.sign_post_installation_location}
                      onChange={this.handleChange}
                      isError={errorFields.sign_post_installation_location}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <TextInput
                      fullWidth
                      label="Are there any specific HOA guidelines?"
                      name="hoa_guidelines"
                      placeholder="The sign must be near the middle of the yard."
                      value={form.hoa_guidelines}
                      onChange={this.handleChange}
                      isError={errorFields.hoa_guidelines}
                    />
                  </Col>
                </Row>
              </>
               ) : null}
           </SectionWrap>
         )} */}
         {false && dealID && (
           <SectionWrap>
             <h6>Upload Files</h6>
             <Row noMargin>
               <Col>
                 <p>
                 Please upload fully executed contract documents for your TC to begin your transaction.
                   <br />
                   <br />
                 If your TC does not have your CAR, MLS, and/or DocuSign logins,
                 please email those to your assigned TC directly:
                 </p>
                 <UploadWrap>
                   <input type="file" onChange={() => { }} />
                 </UploadWrap>
               </Col>
             </Row>
           </SectionWrap>
            )}
         <SectionWrap>
           <h6>Total Commission Details</h6>
           <div
             style={{
               display: "grid",
               gridTemplateColumns: "1fr 1fr",
               gap: "16px", // Adjust spacing between items
             }}
           >
             <div>
               <Label>Total Team Commission</Label>
               <InputNumber
                 name={"Total Team Commission"}
                 placeholder=""
                 disabled
                 formatter={value => (value === undefined || value === null) ? '' : `$${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                 parser={value => (value === undefined || value === null || value === '$') ? null : value.replace(/\$\s?|(,*)/g, '')}
                 value={totals.totalTeamCommission.toFixed(2)}

               />
             </div>
             <div>
               <Label>Total Brokerage Fee</Label>
               <InputNumber
                 name={"Total Brokerage Fee"}
                 placeholder=""
                 disabled
                 formatter={value => (value === undefined || value === null) ? '' : `$${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                 parser={value => (value === undefined || value === null || value === '$') ? null : value.replace(/\$\s?|(,*)/g, '')}
                 value={totals.totalBrokerageFee.toFixed(2)}

               />
             </div>
             <div>
               <Label>Total Audit Fee</Label>
               <InputNumber
                 name={"Total Audit Fee"}
                 placeholder=""
                 disabled
                 formatter={value => (value === undefined || value === null) ? '' : `$${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                 parser={value => (value === undefined || value === null || value === '$') ? null : value.replace(/\$\s?|(,*)/g, '')}
                 value={totals.totalAuditFee.toFixed(2)}

               />
             </div>
             <div>
               <Label>Total Pending Software Fee</Label>
               <InputNumber
                 name={"Total Pending Software Fee"}
                 placeholder=""
                 disabled
                 formatter={value => (value === undefined || value === null) ? '' : `$${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                 parser={value => (value === undefined || value === null || value === '$') ? null : value.replace(/\$\s?|(,*)/g, '')}
                 value={totals.totalPendingSubscriptionFee.toFixed(2)}

               />
             </div>
             <div>
               <Label>Total E&O Fee</Label>
               <InputNumber
                 name={"Total E&O Fee"}
                 placeholder=""
                 disabled
                 formatter={value => (value === undefined || value === null) ? '' : `$${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                 parser={value => (value === undefined || value === null || value === '$') ? null : value.replace(/\$\s?|(,*)/g, '')}
                 value={totals.totalEOFee.toFixed(2)}

               />
             </div>
             <div>
               <Label>Total Internal Referral Fee</Label>
               <InputNumber
                 name={"Total Internal Referral Fee"}
                 placeholder=""
                 disabled
                 formatter={value => (value === undefined || value === null) ? '' : `$${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                 parser={value => (value === undefined || value === null || value === '$') ? null : value.replace(/\$\s?|(,*)/g, '')}
                 value={totals.totalInternalReferralFee.toFixed(2)}

               />
             </div>
             <div>
               <Label>Total Radius Fee</Label>
               <InputNumber
                 name={"Total Radius Fee"}
                 placeholder=""
                 disabled
                 formatter={value => (value === undefined || value === null) ? '' : `$${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                 parser={value => (value === undefined || value === null || value === '$') ? null : value.replace(/\$\s?|(,*)/g, '')}
                 value={totals.totalRadiusFee.toFixed(2)}

               />
             </div>
             <div>
               <Label>Total Miscellaneous Fee</Label>
               <InputNumber
                 name={"Total Miscellaneous Fee"}
                 placeholder=""
                 disabled
                 formatter={value => (value === undefined || value === null) ? '' : `$${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                 parser={value => (value === undefined || value === null || value === '$') ? null : value.replace(/\$\s?|(,*)/g, '')}
                 value={totals.totalMiscellaneousFee.toFixed(2)}

               />
             </div>
           </div>
         </SectionWrap>
         <ToastContainer />
       </Wrap>
     )}
     </>
    )
  }
}

export default container(withRouter(AddNewDeal))